import { useEffect, useState, useRef } from "react";
import * as cmFun from "common/ulti/commonFunction";
import * as CONSTANTS from "common/ulti/constants";
import * as cltDanhMucIgateServirces from "controller/services/cltDanhMucIgateServirces";
import { __DEV__ } from "../../../common/ulti/constants";
import { confirmAlert } from "react-confirm-alert";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { HCCCD_API } from "controller/api";

// antd
import { Button, Breadcrumb, Divider } from "antd";
import {
  FormWrapper,
  FormInputAntd,
  TableGiayToKemTheo,
} from "../../components";
import ChiTietHoSoXoaThuongTruTamTru from "./chiTietHoSoXoaThuongTruTamTru";
// import TienTrinhHoSo from "./tienTrinhHoSo";
import { fetchToastNotify } from "../../../controller/redux/app-reducer";
import { HOME_PAGE } from "config";
import { expanderStyles, captionSubject, txtBreakLine } from "./styles";
import TableKetQuaTTHC from "interface/components/table/tableKetQuaTTHC";
// import { PaperclipOutlined } from "@ant-design/icons";

function ChiTietHoSoIgate() {
  const formThongTinChiTietRef = useRef({});
  const [form, setForm] = useState({
    nation: {
      label: "Việt Nam",
      value: "5f39f4a95224cf235e134c5c",
    },
    isOwnerDossier: false,
    organization: "",
    fullname: "",
    identityDate: "",
    gender: null,
    email: "",
    note: "",
    identityAgency: null,
  });

  const [formThongTinChiTiet, setFormThongTinChiTiet] = useState({});
  const category_id = "5f3a491c4e1bd312a6f00032"; //Loại nhãn mặc định của Hình thức nhận kết quả
  const [editable, setEditable] = useState(true);
  const LoginRes = useSelector((state) => state.LoginRes);
  const Profile = useSelector((state) => state.Profile);
  const dispatch = useDispatch();
  const { type, id } = useParams();
  const [step, setStep] = useState(1);
  const [hasMountedStep2, setHasMountedStep2] = useState(false);
  const formRefAttaches = useRef(0);
  // const path = window.location.pathname.split("/")[2];
  const [isInsert, setIsInsert] = useState(id == 0 ? true : false);
  // const [error, setError] = useState(false);
  const [dsTinh, setDsTinh] = useState([]);
  const [dsXaPhuong, setDsXaPhuong] = useState([]);
  const [dsCoQuanCapCccd, setDsCoQuanCapCccd] = useState([]);
  const [dsGiayTo, setDsGiayTo] = useState([]);
  const [dsFileDinhKem, setDsFileDinhKem] = useState([]);
  const [dsFileSubmit, setDsFileSubmit] = useState([]);
  const [dsHinhThucNhanKq, setDsHinhThucNhanKq] = useState([]);
  const [hinhThucNhankq, setHinhThucNhankq] = useState([]);
  const [inForHoSo, setInForHoSo] = useState({});
  const [dataSubmit, setDataSubmit] = useState({});
  const [pidThuTuc, setPidThuTuc] = useState("");
  const [dataFormThongTinChung, setDataFormThongTinChung] = useState(null);
  const [dataFormThongTinChiTiet, setDataFormThongTinChiTiet] = useState(null);
  const [dsCoQuan, setDsCoQuan] = useState([]);
  const [idDonViSelected, setIdDonViSelected] = useState("");
  const [danhMucTTHC, setDanhMucTTHC] = useState("");
  const [collection, setCollection] = useState("");
  const [dsfileMauIgate, setDsfileMauIgate] = useState([]);
  const [fileMauGoc, setFileMauGoc] = useState([]);
  const [dataFileMau, setDataFileMau] = useState([]);
  const [dsQuyTrinh, setDsQuyTrinh] = useState([]);
  const [idQuyTrinh, setIdQuyTrinh] = useState("");
  const [idApplicantEForm, setIdApplicantEForm] = useState(null); // id form thông tin chung
  const [idEform, setIdEform] = useState(null);
  const [collapsedPanels, setCollapsedPanels] = useState({});
  const [schemaFormChiTiet, setSchemaFormChiTiet] = useState({});
  const [first, setFirst] = useState(false);
  const [applicantNyc, setApplicantNyc] = useState({});
  const [loadingApplicantNyc, setLoadingApplicantNyc] = useState(false);

  const isLienThongKhaiTuRoute =
    typeof type !== "undefined" &&
    type?.includes(
      "ho-so-lien-thong-khai-tu-thuong-tru-tam-tru"
    );

  const getMaXaValue = (maXa) => {
    if (maXa && typeof maXa === "object" && "value" in maXa) return maXa.value;
    return maXa;
  };

  const isTamKy =
    `${getMaXaValue(Profile?.me_info?.noiohientai?.maXa || "")}` === "20341";

  const shouldShowApplicantNyc = !isTamKy;

  function getCurrentDateParts() {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    return { day, month, year };
  }
  const { day, month, year } = getCurrentDateParts();

  const [dsXaPhuongByGroup, setDsXaPhuongByGroup] = useState({});
  async function fetchXaPhuongDynamic(prefix, maTinhObj) {
    const maTinh =
      typeof maTinhObj === "object" && maTinhObj !== null
        ? maTinhObj.value
        : maTinhObj;
    if (!maTinh) return;

    try {
      const payload = { "parent.id": maTinh };
      const res = await cltDanhMucIgateServirces.getDanhMucXaPhuong(maTinh);

      if (!Array.isArray(res?._embedded)) return;

      const list = res._embedded.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      setDsXaPhuongByGroup((prev) => ({
        ...prev,
        [prefix]: list,
      }));
    } catch (err) {
      console.warn(`⚠️ Lỗi khi tải xã/phường cho cụm [${prefix}]:`, err);
    }
  }

  const LAYOUT_TYPES = new Set([
    "panel",
    "columns",
    "fieldset",
    "well",
    "row",
    "table",
  ]);

  const ADDRESS_KEYS = new Set(["quocGia", "maTinh", "maHuyen", "maXa"]);
  const DATE_PART_KEYS = new Set(["ngaySinh", "thangSinh", "namSinh"]);
  const FORCE_NULL_KEYS = new Set(["identityAgency"]);

  function buildSchemaFormChiTiet(components) {
    const result = {};

    const traverse = (items, target) => {
      if (!Array.isArray(items)) return;

      items.forEach((comp) => {
        if (!comp || !comp.key) {
          if (comp && comp.type === "table" && Array.isArray(comp.rows)) {
            comp.rows.forEach((row) => {
              row.forEach((cell) => traverse(cell?.components, target));
            });
          }
          if (comp && comp.type === "tabs" && Array.isArray(comp.components)) {
            traverse(comp.components, target);
          }
          return;
        }

        const { key, type } = comp;

        if (LAYOUT_TYPES.has(type)) {
          if (Array.isArray(comp.columns)) {
            comp.columns.forEach((col) => traverse(col.components, target));
          }
          if (type === "table" && Array.isArray(comp.rows)) {
            comp.rows.forEach((row) => {
              row.forEach((cell) => traverse(cell?.components, target));
            });
          }

          if (Array.isArray(comp.components)) {
            traverse(comp.components, target);
          }
          return;
        }

        if (type === "container") {
          target[key] = {};
          traverse(comp.components, target[key]);
          return;
        }
        if (type === "datagrid" || type === "editgrid") {
          target[key] = [{}];
          traverse(comp.components, target[key][0]);
          return;
        }
        if (type === "number" || DATE_PART_KEYS.has(key)) {
          target[key] = null;
          return;
        }
        if (ADDRESS_KEYS.has(key)) {
          target[key] = {};
          return;
        }
        if (FORCE_NULL_KEYS.has(key)) {
          target[key] = null;
          return;
        }
        target[key] = "";
      });
    };

    traverse(components, result);
    return result;
  }

  useEffect(() => {
    const tinhSelect = dsTinh?.filter(item => item.label === "Thành phố Đà Nẵng");
    setForm((prev) => ({
      ...prev,
      province: tinhSelect?.[0]
    }))
    if (!inForHoSo?.ThongTinHoSo?.DiaChi?.TenDonViHanhChinh) return;
    const xaPhuongSelect = dsXaPhuong?.filter(item => item?.label === inForHoSo?.ThongTinHoSo?.DiaChi?.TenDonViHanhChinh)
    setForm((prev) => ({
      ...prev,
      village: xaPhuongSelect?.[0]
    }))
  }, [inForHoSo, dsXaPhuong, dsTinh]);

  useEffect(() => {
    if (!shouldShowApplicantNyc) return;
    if (!id || `${id}` === "0") return;

    let isMounted = true;
    (async () => {
      try {
        setLoadingApplicantNyc(true);
        const res = await cltDanhMucIgateServirces.getApplicantNyc(id);
        if (!isMounted) return;
        setApplicantNyc(res || {});
      } catch (err) {
        if (!isMounted) return;
        setApplicantNyc({});
      } finally {
        if (!isMounted) return;
        setLoadingApplicantNyc(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [shouldShowApplicantNyc, id]);

  const getApplicantNycField = (keys, fallback = "") => {
    for (const k of keys) {
      const v = applicantNyc?.[k];
      if (v !== undefined && v !== null && `${v}`.trim() !== "") return v;
    }
    return fallback;
  };

  const handleChgApplicantNyc = (evt) => {
    const fieldId = evt?.target?.id;
    const value = evt?.target?.value;
    if (!fieldId) return;

    setApplicantNyc((prev) => {
      const next = { ...(prev || {}) };
      if (fieldId === "nycFullname") {
        next.fullname = value;
        next.nycHoTen = value;
        return next;
      }
      if (fieldId === "nycIdentityNumber") {
        next.identityNumber = value;
        next.nycSoGiayToTuyThan = value;
        return next;
      }
      if (fieldId === "nycPhoneNumber") {
        next.phoneNumber = value;
        next.nycSoDienThoai = value;
        return next;
      }
      if (fieldId === "nycEmail") {
        next.email = value;
        next.nycEmail = value;
        return next;
      }
      if (fieldId === "nycAddress") {
        next.address = value;
        next.nycDiaChi = value;
        return next;
      }
      next[fieldId] = value;
      return next;
    });
  };


  // Đồng bộ ref với state để validate luôn đọc đúng dữ liệu
  useEffect(() => {
    formThongTinChiTietRef.current = formThongTinChiTiet;
  }, [formThongTinChiTiet]);
  // Lấy cấu trúc Eform chi tiết
  useEffect(() => {
    const comps = dataFormThongTinChiTiet?.components;
    if (!Array.isArray(comps)) return;
    const schema = buildSchemaFormChiTiet(comps);
    setFormThongTinChiTiet((prev) => ({
      ...schema,
      ...prev,
    }));
    if (schema) {
      setFirst(true);
    }
    setSchemaFormChiTiet(schema);
  }, [dataFormThongTinChiTiet]);

  // get Thông tin chi tiết Form trước
  useEffect(() => {
    if (schemaFormChiTiet === null) return;
    const fetchEformData = async () => {
      if (!collection || !id) return;
      try {
        const resHoSoTTHC = await cltDanhMucIgateServirces.getHoSoTTHC(
          collection,
          id
        );
        if (!resHoSoTTHC) return;
        if (resHoSoTTHC?.applicant?.id) {
          setIdApplicantEForm(resHoSoTTHC?.applicant?.id || null);
        }
        if (resHoSoTTHC?.eForm?.id) {
          setIdEform(resHoSoTTHC?.eForm?.id || null);
        }
        if (resHoSoTTHC?.pid) {
          setPidThuTuc(resHoSoTTHC?.pid || null);
        }
        setInForHoSo(resHoSoTTHC);
        if (resHoSoTTHC?.pdid) {
          setIdQuyTrinh(resHoSoTTHC?.pdid || null);
        }
        function getValueByPath(obj, path) {
          return path.split(".").reduce((acc, key) => acc?.[key], obj);
        }

        // 🧩 Hàm chuẩn hóa 1 object form (dùng chung cho cả thông tin chung & chi tiết)
        const normalizeFormData = (rawData, schemaFormChiTiet = {}) => {
          Object.keys(rawData).forEach((key) => {
            const value = rawData[key];

            // 🧩 Kiểm tra schemaFormChiTiet có trường hovaten_* không
            const hasHovatenField = (keyName) => {
              const schemaField = schemaFormChiTiet?.[keyName];
              if (!schemaField || typeof schemaField !== "object") return false;
              return Object.keys(schemaField).some((k) =>
                /^hovaten(_?[a-z0-9]*)$/i.test(k)
              );
            };

            // ✅ Họ tên
            if (
              key.toLowerCase().includes("hoten") &&
              typeof value === "string"
            ) {
              const parts = value.trim().split(/\s+/);
              const len = parts.length;

              rawData[key] = {
                Ho: parts[0] || "",
                ChuDem: len > 2 ? parts.slice(1, len - 1).join(" ") : "",
                Ten: len > 1 ? parts[len - 1] : "",
              };

              // ➕ Nếu schema có định nghĩa hovaten_*, thêm vào
              if (hasHovatenField(key)) {
                const hovatenKey = Object.keys(schemaFormChiTiet[key]).find(
                  (k) => /^hovaten(_?[a-z0-9]*)$/i.test(k)
                );
                rawData[key][hovatenKey] = value.trim();
              }
            }

            // ✅ Ngày sinh
            else if (
              key.toLowerCase().includes("ngaysinh") &&
              typeof value === "string"
            ) {
              const parts = value.trim().split(/[\/\-]/);
              if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
                const [ngay, thang, nam] = parts.map((p) => p.padStart(2, "0"));
                rawData[key] = {
                  ngaySinh: ngay,
                  thangSinh: thang,
                  namSinh: nam,
                };
              } else {
                rawData[key] = {
                  ngaySinh: "",
                  thangSinh: "",
                  namSinh: "",
                };
              }
            }

            // ✅ Ngày chết
            else if (
              key.toLowerCase().includes("ngaychet") &&
              typeof value === "string"
            ) {
              const [datePart, timePart] = value.trim().split(" ");
              const [day, month, year] = datePart
                .split(/[\/\-]/)
                .map((p) => p.padStart(2, "0"));
              if (day && month && year) {
                const iso = new Date(
                  `${year}-${month}-${day}T17:00:00.000Z`
                ).toISOString();
                const time = timePart?.trim() || "";
                rawData[key] = iso;
                if (time) rawData["nktGioPhutChet1"] = time;
                if (time) rawData["nktGioPhutChet"] = time;
              }
            }

            // ✅ Duyệt key con nếu có
            if (typeof value === "object" && value !== null) {
              Object.keys(value).forEach((subKey) => {
                const subVal = value[subKey];

                // 🟢 Họ tên con
                if (
                  subKey.toLowerCase().includes("hoten") &&
                  typeof subVal === "string"
                ) {
                  const parts = subVal.trim().split(/\s+/);
                  const len = parts.length;
                  value[subKey] = {
                    Ho: parts[0] || "",
                    ChuDem: len > 2 ? parts.slice(1, len - 1).join(" ") : "",
                    Ten: len > 1 ? parts[len - 1] : "",
                  };

                  // ➕ Nếu schema có định nghĩa hovaten_* thì thêm vào
                  if (hasHovatenField(subKey)) {
                    const hovatenKey = Object.keys(
                      schemaFormChiTiet[subKey]
                    ).find((k) => /^hovaten(_?[a-z0-9]*)$/i.test(k));
                    value[subKey][hovatenKey] = subVal.trim();
                  }
                }

                // 🔵 Ngày sinh con
                else if (
                  subKey.toLowerCase().includes("ngaysinh") &&
                  typeof subVal === "string"
                ) {
                  const parts = subVal.trim().split(/[\/\-]/);
                  if (parts.length === 3) {
                    const [ngay, thang, nam] = parts.map((p) =>
                      p.padStart(2, "0")
                    );
                    value[subKey] = {
                      ngaySinh: ngay,
                      thangSinh: thang,
                      namSinh: nam,
                    };
                  }
                }

                // 🔴 Ngày chết con
                else if (
                  subKey.toLowerCase().includes("ngaychet") &&
                  typeof subVal === "string"
                ) {
                  const [datePart, timePart] = subVal.trim().split(" ");
                  const [day, month, year] = datePart
                    .split(/[\/\-]/)
                    .map((p) => p.padStart(2, "0"));
                  if (day && month && year) {
                    const iso = new Date(
                      `${year}-${month}-${day}T17:00:00.000Z`
                    ).toISOString();
                    const time = timePart?.trim() || "";
                    value[subKey] = iso;
                    if (time) rawData["nktGioPhutChet"] = time;
                  }
                }
              });
            }
          });

          return rawData;
        };

        // ✅ Lấy dữ liệu cho form thông tin chung
        const formData = (danhMucTTHC?.formThongTinChungIgate || []).reduce(
          (acc, item) => {
            const value = getValueByPath(resHoSoTTHC, item.query);
            if (value === undefined) return acc;

            if (item.key.includes(".")) {
              const [parentKey, childKey] = item.key.split(".");
              if (!acc[parentKey] || typeof acc[parentKey] !== "object")
                acc[parentKey] = {};
              acc[parentKey][childKey] = value;
            } else acc[item.key] = value;

            return acc;
          },
          {}
        );

        // ✅ Lấy dữ liệu cho form thông tin chi tiết
        const formThongTinChiTietData = (
          danhMucTTHC?.formThongTinChiTietIgate || []
        ).reduce((acc, item) => {
          const value = getValueByPath(resHoSoTTHC, item.query);
          if (value === undefined) return acc;

          if (item.key.includes(".")) {
            const [parentKey, childKey] = item.key.split(".");
            if (!acc[parentKey] || typeof acc[parentKey] !== "object")
              acc[parentKey] = {};
            acc[parentKey][childKey] = value;
          } else acc[item.key] = value;

          return acc;
        }, {});
        // ✅ Chuẩn hóa cả 2 form
        const normalizedFormData = normalizeFormData(formData);
        const normalizedFormThongTinChiTiet = normalizeFormData(
          formThongTinChiTietData,
          schemaFormChiTiet
        );

        // ✅ Set state — merge logic giống nhau
        if (resHoSoTTHC?.applicant?.id) {
          setForm({
            ...resHoSoTTHC?.applicant?.data,
            ownerFullname:
              resHoSoTTHC?.data?.ownerFullname ||
              resHoSoTTHC?.ThongTinHoSo?.TenHS ||
              "",
            fullname:
              resHoSoTTHC?.data?.fullname ||
              resHoSoTTHC?.ThongTinHoSo?.NguoiLamHS?.hovaten ||
              "",
            giayToDinhKem: resHoSoTTHC?.giayToDinhKem || [], // Giữ nguyên giayToDinhKem ngoại lệ
          });

          setFormThongTinChiTiet(resHoSoTTHC?.eForm?.data || {});
        } else {
          setForm((prev) => ({
            ...prev,
            ...normalizedFormData,
            giayToDinhKem: resHoSoTTHC?.giayToDinhKem || [], // Giữ nguyên giayToDinhKem ngoại lệ
          }));

          setFormThongTinChiTiet((prev) => ({
            ...prev,
            ...normalizedFormThongTinChiTiet,
          }));
        }
        if (Array.isArray(resHoSoTTHC?.dossierFormFile)) {
          setDsFileSubmit(resHoSoTTHC.dossierFormFile);
        }

        const trangThai = resHoSoTTHC?.TrangThaiHoSo?.Ma;
        setEditable(trangThai === "1"); // Trạng thái hồ sơ có mã = 1 thì cho phép sửa 

        if (resHoSoTTHC?.dossierReceivingKind?.id) {
          setHinhThucNhankq({
            value: resHoSoTTHC.dossierReceivingKind.id,
            label: resHoSoTTHC.dossierReceivingKind.name?.[0]?.name || "",
          });
        }

        if (!resHoSoTTHC?.pid) return;
        const resGiayTo = await cltDanhMucIgateServirces.getDanhSachGiayTo(
          resHoSoTTHC?.pid
        );

        setDsfileMauIgate(
          resGiayTo?.content?.map((item) => {
            return {
              linkFileMau: item?.fileLink,
              nameFileMau: item?.fileLinkName,
            };
          })
        );

        // 🗂️ Giấy tờ: lọc trùng theo id
        if (Array.isArray(resGiayTo?.content)) {
          const unique = resGiayTo.content
            .map((item) => ({
              procedureForm: {
                id: item.form?.id ?? null,
                name: item.form?.name ?? "",
              },
              order: item.order ?? null,
              case: { id: idQuyTrinh || item.case?.id || null },
              detail: item.detail?.[0]
                ? {
                  type: {
                    id: item.detail[0].type?.id ?? null,
                    name: item.detail[0].type?.name ?? "",
                  },
                  quantity: item.detail[0].quantity ?? 1,
                }
                : null,
              file: [],
              authentication: {
                type: { id: 2, name: "Chứng thực giấy" },
                pageNumber: 1,
                copiesAmount: 1,
              },
            }))
            .filter(
              (item, idx, arr) =>
                item.procedureForm.id &&
                idx ===
                arr.findIndex(
                  (t) => t.procedureForm.id === item.procedureForm.id
                )
            );
          setDsGiayTo(unique);
        }
      } catch (error) {
        console.error("❌ Lỗi khi lấy dữ liệu eForm:", error);
      }
    };
    fetchEformData();
  }, [collection, id, danhMucTTHC, first]);

  // Lấy pid của thủ tục
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const resDanhMuc = await cltDanhMucIgateServirces.getDanhMucTTHC(
          `/${type}`
        );
        const danhMucTTHC = resDanhMuc?._embedded?.[0];
        if (!danhMucTTHC) return;
        setCollection(resDanhMuc?._embedded?.[0]?.Collection);

        let maTTHC = danhMucTTHC?.MaTTHC;

        // Nếu có dạng "1.000656-1.007073" → lấy phần trước dấu "-"
        if (typeof maTTHC === "string" && maTTHC.includes("-")) {
          maTTHC = maTTHC.split("-")[0]?.trim();
        }

        const newData = {
          ...danhMucTTHC,
          MaTTHC: maTTHC
        };

        setDanhMucTTHC(newData);

        const resCoQuan = await cltDanhMucIgateServirces.getCoQuanXuLyTTHC(maTTHC);

        function mapDonViToOptions(data = []) {
          return data
            .filter((item) => item?.DonVi?.id && item?.DonVi?.name)
            .map((item) => ({
              value: item.DonVi.id,
              label: item.DonVi.name,
              maTTHC: item?.TTHC,
              maDonVi: item?.DonVi?.code,
            }));
        }
        const options = mapDonViToOptions(resCoQuan?._embedded);
        setDsCoQuan(options);
      } catch (err) {
        console.error("❌ Lỗi khi tải pid thủ tục:", err);
      }
    })();
    return () => (isMounted = false);
  }, [type]);

  // hàm get danh sách thủ tục
  useEffect(() => {
    if (!idDonViSelected) return;
    let isMounted = true;
    (async () => {
      try {
        if (!danhMucTTHC?.MaTTHC || !idDonViSelected) return;
        const resThuTuc = await cltDanhMucIgateServirces.getDanhSachThuTucIgate(
          danhMucTTHC?.MaTTHC,
          idDonViSelected?.value
        );
        const pid = resThuTuc?.content?.[0]?.id;
        if (pid && isMounted) setPidThuTuc(pid);
        // 🔹 Lấy danh sách quy trình thực hiện
        const resQuyTrinh =
          await cltDanhMucIgateServirces.getDanhSachQuyTrinhIgatle(pid);
        if (resQuyTrinh?.content?.length > 0) {
          const processOptions = resQuyTrinh?.content.map((item) => ({
            key: item?.id,
            value: item?.processDefinition?.applicantEForm?.id,
            idEform: item?.processDefinition?.eForm?.id,
            label: item?.processDefinition?.name,
            idQuyTrinh: item?.id,
          }));
          setDsQuyTrinh(processOptions);
        } else {
          setDsQuyTrinh([]);
        }
      } catch (err) {
        console.error("❌ Lỗi khi tải pid thủ tục:", err);
      }
    })();
    return () => (isMounted = false);
  }, [idDonViSelected, danhMucTTHC?.MaTTHC]);

  useEffect(() => {
    const fetchEformData = async () => {
      try {
        if (idApplicantEForm) {
          const resEform =
            await cltDanhMucIgateServirces.getDanhMucEform(idApplicantEForm);
          setDataFormThongTinChung(resEform);
        }
        if (idEform) {
          const resEform =
            await cltDanhMucIgateServirces.getDanhMucEform(idEform);
          setDataFormThongTinChiTiet(resEform);
        }
      } catch (error) {
        console.error("Lỗi khi lấy dữ liệu eForm:", error);
      }
    };
    if (idApplicantEForm) {
      fetchEformData();
    }
  }, [idApplicantEForm]);

  // 🧩 2️⃣ Khi đã có pidThuTuc, tải danh mục & eForm
  useEffect(() => {
    if (!pidThuTuc) return;

    let isMounted = true;
    (async () => {
      try {
        const [resTinh, resCoQuan, resHinhThucNhanKq, resGiayTo] =
          await Promise.all([
            cltDanhMucIgateServirces.getDanhMucTinh(),
            cltDanhMucIgateServirces.getDanhMucCoQuanCapCccd(),
            cltDanhMucIgateServirces.getDanhSachHinhThucNhanKetQua(category_id),
            cltDanhMucIgateServirces.getDanhSachGiayTo(pidThuTuc),
          ]);

        if (!isMounted) return;

        setDsfileMauIgate(
          resGiayTo?.content?.map((item) => {
            return {
              linkFileMau: item?.fileLink,
              nameFileMau: item?.fileLinkName,
            };
          })
        );

        // 🗂️ Giấy tờ: lọc trùng theo id
        if (Array.isArray(resGiayTo?.content)) {
          const unique = resGiayTo.content
            .map((item) => ({
              procedureForm: {
                id: item.form?.id ?? null,
                name: item.form?.name ?? "",
              },
              order: item.order ?? null,
              case: { id: idQuyTrinh || item.case?.id || null },
              detail: item.detail?.[0]
                ? {
                  type: {
                    id: item.detail[0].type?.id ?? null,
                    name: item.detail[0].type?.name ?? "",
                  },
                  quantity: item.detail[0].quantity ?? 1,
                }
                : null,
              file: [],
              authentication: {
                type: { id: 2, name: "Chứng thực giấy" },
                pageNumber: 1,
                copiesAmount: 1,
              },
            }))
            .filter(
              (item, idx, arr) =>
                item.procedureForm.id &&
                idx ===
                arr.findIndex(
                  (t) => t.procedureForm.id === item.procedureForm.id
                )
            );
          setDsGiayTo(unique);
        }

        // 📜 Danh mục Hình thức nhận KQ
        if (resHinhThucNhanKq?.content) {
          setDsHinhThucNhanKq(
            resHinhThucNhanKq.content.map((i) => ({
              value: i.id,
              label: i.name,
            }))
          );
        }
        setDsTinh(
          resTinh?._embedded?.map((i) => ({ label: i.name, value: i.id })) || []
        );
        setDsCoQuanCapCccd(
          resCoQuan?._embedded?.map((i) => {
            const { _id, ...rest } = i;
            return {
              label: i.name,
              value: i.id,
              raw: rest,
            };
          }) || []
        );
      } catch (err) {
        console.error("❌ Lỗi khi tải danh mục & eForm:", err);
      }
    })();
    return () => (isMounted = false);
  }, [idApplicantEForm, idQuyTrinh]);

  // Lấy thông tin file mẫu
  useEffect(() => {
    const fetchFileMau = async () => {
      if (!danhMucTTHC?.MaTTHC) return;
      try {
        const res = await cltDanhMucIgateServirces.getDanhMucFileMauIgate(
          danhMucTTHC?.MaTTHC
        );
        const data = res?._embedded?.[0]?.dataFileMau || [];
        setFileMauGoc(data);
      } catch (err) {
        console.error("❌ Lỗi tải file mẫu:", err);
      }
    };
    if (idApplicantEForm) {
      fetchFileMau();
    }
  }, [idApplicantEForm]);

  // 🔹 Khi form thay đổi → hydrate dữ liệu vào file mẫu
  useEffect(() => {
    const hydrateData = async () => {
      if (!form || fileMauGoc.length === 0) return;
      const res = await getFileMauHydrated(fileMauGoc, form, {
        HCCCD_API,
        day,
        month,
        year,
      });
      setDataFileMau(res);
    };

    hydrateData();
  }, [form, fileMauGoc]);

  // 🧩 3️⃣ Khi thay đổi Tỉnh, tải danh sách xã phường
  useEffect(() => {
    if (!form?.province?.value) return;
    cltDanhMucIgateServirces
      .getDanhMucXaPhuong(form?.province?.value)
      .then((res) => {
        if (!Array.isArray(res?._embedded)) return;
        setDsXaPhuong(
          res._embedded.map((item) => ({ label: item.name, value: item.id }))
        );
      })
      .catch((err) => console.warn("⚠️ Lỗi khi tải xã phường:", err));
  }, [form?.province?.value]);

  // 🧩 5️⃣ Khi thay đổi tên chủ hồ sơ, cập nhật nội dung yêu cầu
  useEffect(() => {
    if (!form?.ownerFullname) return;
    setForm((prev) => ({
      ...prev,
      noidungyeucaugiaiquyet: `ÔNG/BÀ: ${prev.ownerFullname} (chủ hồ sơ) ĐỀ NGHỊ GIẢI QUYẾT ${danhMucTTHC?.Ten}`,
    }));
  }, [form?.ownerFullname, danhMucTTHC]);

  // 🧩 6️⃣ Khi có hồ sơ & danh sách giấy tờ → xử lý danh sách file đính kèm
  useEffect(() => {
    if (!inForHoSo?.dossierFormFile?.length || !dsGiayTo?.length) return;

    const processed = inForHoSo.dossierFormFile.map((item) => {
      const matchIndex = dsGiayTo.findIndex(
        (g) => g.procedureForm?.id === item.procedureForm?.id
      );
      return {
        stt: matchIndex >= 0 ? matchIndex + 1 : 9999,
        inFo: {
          ...item,
          file: Array.isArray(item.file)
            ? item.file.map((f) => ({
              ...f,
              name: f.filename || f.name,
              filename: f.filename || f.name,
              url:
                f.url || f.path || f.downloadUrl || f.fileDownloadUri || "",
            }))
            : [],
        },
      };
    });
    processed.sort((a, b) => a.stt - b.stt);
    setDsFileDinhKem(processed);
    setDsFileSubmit(inForHoSo.dossierFormFile);
  }, [inForHoSo?.dossierFormFile, dsGiayTo]);

  function flattenAndNormalize(input) {
    const out = {};

    for (const [rawKey, value] of Object.entries(input)) {
      // Bỏ qua các trường bắt đầu bằng _init
      if (rawKey.startsWith("_init")) continue;

      const parts = String(rawKey).split("_");

      // Nếu không có dấu "_" → giữ nguyên
      if (parts.length === 1) {
        out[rawKey] = value;
        continue;
      }

      const prefix = parts[0];
      const rest = parts.slice(1);

      // Nếu chỉ có 1 phần sau prefix → bỏ prefix
      if (rest.length === 1) {
        const field = rest[0];
        out[field] = value;
        continue;
      }

      // Nếu có >= 2 phần → nhóm
      const field = rest[rest.length - 1];
      const group = rest.slice(0, rest.length - 1).join("_");

      if (
        !out[group] ||
        typeof out[group] !== "object" ||
        Array.isArray(out[group])
      ) {
        out[group] = {};
      }
      out[group][field] = value;
    }

    // ✅ Chuẩn hóa giá trị: chỉ giữ object cho maTinh, maXa, quocGia
    const normalizeValue = (val, fieldName) => {
      // 🔹 Giữ nguyên object {label,value} cho 3 trường đặc biệt
      if (["maTinh", "maXa", "quocGia"].includes(fieldName)) {
        // Nếu là object có sẵn label/value → giữ nguyên
        if (
          val &&
          typeof val === "object" &&
          "label" in val &&
          "value" in val
        ) {
          return val;
        }

        // Nếu là string → chuyển sang object {label,value}
        if (typeof val === "string" && val.trim() !== "") {
          // Nếu là maTinh → tra trong dsTinh
          if (fieldName === "maTinh" && Array.isArray(dsTinh)) {
            const match = dsTinh.find((t) => String(t.value) === String(val));
            if (match) return { label: match.label, value: match.value };
          }

          // Nếu là maXa → tra trong dsXaPhuongByGroup
          if (fieldName === "maXa" && typeof dsXaPhuongByGroup === "object") {
            const allXa = Object.values(dsXaPhuongByGroup).flat();
            const match = allXa.find((x) => String(x.value) === String(val));
            if (match) return { label: match.label, value: match.value };
          }

          // Nếu là quocGia
          if (fieldName === "quocGia") {
            const label = val === "VN" ? "Việt Nam" : val;
            return { label, value: val };
          }

          // Nếu không tìm thấy thì vẫn wrap lại
          return { label: val, value: val };
        }

        // Nếu là null/undefined → bỏ qua
        return val;
      }

      // 🔹 Các field khác: nếu là object có {label,value} thì chỉ lấy value
      if (val && typeof val === "object" && "label" in val && "value" in val) {
        return val.value;
      }

      return val;
    };

    const deepNormalize = (obj) => {
      if (typeof obj !== "object" || obj === null) return obj;
      if (Array.isArray(obj)) return obj.map((v) => deepNormalize(v));

      const res = {};
      for (const [k, v] of Object.entries(obj)) {
        if (k.startsWith("_init")) continue;
        res[k] = deepNormalize(normalizeValue(v, k));
      }
      return res;
    };

    const result = deepNormalize(out);

    return result;
  }

  /**
   * Chuyển đổi các trường từ dạng object sang giá trị đơn giản
   */
  function simplifyFormFields(
    formData,
    fieldsToSimplify = ["gender", "chonDoiTuong", "hinhThucNop"]
  ) {
    if (!formData || typeof formData !== "object") return formData;

    const result = { ...formData };

    // Xử lý các trường cần chuyển đổi
    fieldsToSimplify.forEach((field) => {
      if (
        result[field] &&
        typeof result[field] === "object" &&
        result[field].value !== undefined
      ) {
        // Chuyển từ object sang giá trị đơn giản
        result[field] = result[field].value;

        // Nếu giá trị là số dạng chuỗi, chuyển thành số
        if (!isNaN(result[field])) {
          result[field] = Number(result[field]);
        }
      }
    });

    return result;
  }
  // build form submit
  useEffect(() => {
    setDataSubmit({
      agency:
        inForHoSo?.agency ||
        (idDonViSelected?.label &&
          idDonViSelected?.maDonVi &&
          idDonViSelected?.value
          ? {
            ten: idDonViSelected.label,
            ma: idDonViSelected.maDonVi,
            organkey: idDonViSelected.value,
          }
          : undefined),
      applicant: {
        id: idApplicantEForm,
        data: { ...simplifyFormFields(form) },
      },
      eForm: {
        id: idEform,
        data: { ...flattenAndNormalize(formThongTinChiTiet) },
      },
      dossierReceivingKind: {
        id: hinhThucNhankq?.value,
        name: [
          {
            languageId: 228,
            name: hinhThucNhankq?.label,
          },
        ],
      },
      dossierFormFile: dsFileSubmit,
      ThongTinHoSo: {
        TenHS: form?.ownerFullname || "",
        NguoiLamHS: {
          email: form?.email || "",
          sodienthoai: form?.phoneNumber || "",
          hovaten: form?.fullname || "",
        },
        DonViTiepNhanXuLyHS: "",
      },
      TrangThaiHoSo: {
        Ma: "2",
        MoTa: "Chờ duyệt",
        ThoiGianXuLy: new Date().getTime(),
        GhiChu: "",
        ThongBaoKetQua: "",
        KetQua: "",
      },
      LoaiHoSo: inForHoSo?.LoaiHoSo || {
        Ten: danhMucTTHC?.Ten,
        Ma: danhMucTTHC?.Ma,
        Link: danhMucTTHC?.link,
      },
      pid: pidThuTuc || "", // pid là id của thủ tục gọi qua api số 3
      pcode: danhMucTTHC?.MaTTHC + ".H17" || "", // pcode là mã của thủ tục
      pdid: idQuyTrinh || "", // pdid là id của quy trình
    });
  }, [
    form,
    inForHoSo,
    pidThuTuc,
    idDonViSelected,
    danhMucTTHC,
    dsFileSubmit,
    hinhThucNhankq,
    formThongTinChiTiet,
    idQuyTrinh,
    idApplicantEForm,
    idEform,
  ]);

  const handleChgConElmt = (evt) => {
    let id, value;

    // --- Trường hợp input, textarea, checkbox chuẩn ---
    if (evt && evt.target) {
      id = evt.target.id;
      value =
        evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
    }
    // --- Trường hợp select hoặc custom control ---
    else if (evt && typeof evt === "object" && "id" in evt && "value" in evt) {
      id = evt.id;
      value = evt.value;
    }
    if (!id) return;
    if (id === "isOwnerDossier") {
      setForm((prev) => ({
        ...prev,
        fullname: form?.ownerFullname || "",
      }));
    }
    setForm((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleChgThongTinChiTiet = (evt) => {
    let id, value;
    if (evt?.target) {
      id = evt.target.id;
      value =
        evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
    } else if (
      evt &&
      typeof evt === "object" &&
      "id" in evt &&
      "value" in evt
    ) {
      id = evt.id;
      value = evt.value;
    }
    if (!id) return;

    // 🧩 Chuẩn hóa id: bỏ prefix layout (panel_, row_, col_, ...)
    const stripTokens = new Set([
      "panel",
      "panel1",
      "panel2",
      "row",
      "col",
      "fieldset",
      "container",
      "well",
      "table",
    ]);
    const tokens = String(id)
      .split("_")
      .filter((t) => t && !stripTokens.has(t));

    // 🔹 Xác định nhóm HoTen và field con
    const idxGroup = tokens.findIndex((t) => /HoTen$/i.test(t));
    if (idxGroup === -1) {
      // field khác -> gán trực tiếp
      setFormThongTinChiTiet((prev) => {
        const updated = { ...prev, [id]: value };
        formThongTinChiTietRef.current = updated;
        setDataSubmit((old) => ({
          ...old,
          eForm: { id: idEform, data: flattenAndNormalize(updated) },
        }));
        return updated;
      });
      return;
    }

    const groupKey = tokens[idxGroup]; // ví dụ 'nksHoTen'
    const fieldKey = tokens.slice(idxGroup + 1).join("_") || null; // ví dụ 'hovaten_nks', 'Ho', 'ChuDem', 'Ten'

    // map các key full name chuẩn
    const fullNameMap = {
      nksHoTen: "hovaten_nks",
      chaHoTen: "hovatencha",
      meHoTen: "hovatenme",
      nycHoTen: "hovatennguoiyeucau",
    };

    const splitHoTen = (str) => {
      if (typeof str !== "string" || !str.trim())
        return { Ho: "", ChuDem: "", Ten: "" };
      const parts = str.trim().split(/\s+/);
      return {
        Ho: parts[0] || "",
        ChuDem:
          parts.length > 2 ? parts.slice(1, parts.length - 1).join(" ") : "",
        Ten: parts.length > 1 ? parts[parts.length - 1] : "",
      };
    };

    const composeFull = (obj) =>
      [obj.Ho, obj.ChuDem, obj.Ten]
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();

    setFormThongTinChiTiet((prev) => {
      const current = { ...(prev[groupKey] || {}) };

      // 🟦 Nếu nhập vào field full name (vd: hovaten_nks)
      if (/^hovaten(_[a-z]+)?$/i.test(fieldKey || "")) {
        const nameParts = splitHoTen(value);
        const fullKey = fullNameMap[groupKey] || "hovaten";
        current[fullKey] = value;
        // chỉ cập nhật các trường con nếu trước đó chưa có dữ liệu, tránh ghi đè khi user nhập riêng
        current.Ho = current.Ho || nameParts.Ho;
        current.ChuDem = current.ChuDem || nameParts.ChuDem;
        current.Ten = current.Ten || nameParts.Ten;
      }
      // 🟩 Nếu nhập vào Ho / ChuDem / Ten
      else if (["Ho", "ChuDem", "Ten"].includes(fieldKey)) {
        current[fieldKey] = value;
        const fullKey = fullNameMap[groupKey] || "hovaten";
        current[fullKey] = composeFull(current);
      }
      // 🟨 Các field khác trong nhóm
      else {
        current[fieldKey] = value;
      }

      const updated = { ...prev, [groupKey]: current };

      formThongTinChiTietRef.current = updated;
      setDataSubmit((old) => ({
        ...old,
        eForm: { id: idEform, data: flattenAndNormalize(updated) },
      }));
      return updated;
    });
  };

  //ACTION
  const handleCf = (_type = 0, _action, ...args) => {
    confirmAlert({
      title: `${!_type ? "Sửa" : _type < 0 ? "Xóa" : "Thêm"} dữ liệu`,
      message: `Xác nhận ${!_type ? "sửa" : _type < 0 ? "xóa" : "thêm"
        } dữ liệu`,
      buttons: [
        {
          label: "Không",
          onClick: () => {
            return;
          },
        },
        {
          label: "Có",
          onClick: () => _action(...args),
        },
      ],
    });
  };

  async function uploadAllDsFileDinhKem() {
    try {
      const updatedList = await Promise.all(
        dsFileDinhKem.map(async (item) => {
          if (!item?.inFo?.file?.length) return item;

          // Upload từng file mới, giữ nguyên file cũ đã có url/path/filename
          const finalFiles = await Promise.all(
            item.inFo.file.map(async (fileObj) => {
              let fileToUpload = null;

              if (fileObj instanceof File) fileToUpload = fileObj;
              else if (fileObj?.originFileObj) fileToUpload = fileObj.originFileObj;
              else if (fileObj?.preview && !fileObj?.url && !fileObj?.path && !fileObj?.downloadUrl && !fileObj?.fileDownloadUri) {
                const response = await fetch(fileObj.preview);
                const blob = await response.blob();
                const fileName =
                  fileObj?.name ||
                  `file_${new Date().getTime()}.${blob.type.split("/")[1] || "bin"}`;
                fileToUpload = new File([blob], fileName, { type: blob.type });
              }

              // Nếu không phải file mới (đã có url/path/filename hoặc không nhận diện được) thì giữ nguyên
              if (!fileToUpload) {
                return {
                  ...fileObj,
                  filename: fileObj.filename || fileObj.name,
                };
              }

              const res = await cltDanhMucIgateServirces.uploadFileIgate(fileToUpload);
              const uploadedInfo = res?.[0] || res;
              return {
                ...uploadedInfo,
                filename: uploadedInfo.filename || fileToUpload.name,
              };
            })
          );

          // Kết quả: danh sách file gồm cả file cũ (giữ nguyên) và file mới (đã upload)
          return {
            ...item,
            inFo: {
              ...item.inFo,
              file: finalFiles,
            },
          };
        })
      );

      return updatedList;
    } catch (err) {
      console.error("❌ Lỗi khi upload danh sách file:", err);
      return dsFileDinhKem;
    }
  }
  // 🧩 Hàm kiểm tra required field trong eForm
  function validateRequiredFields(eform, formData) {
    const missing = [];

    // Hàm đệ quy lấy giá trị sâu theo path
    const getDeepValue = (obj, path) => {
      if (!obj || typeof path !== "string") return undefined;
      return path.split(".").reduce((acc, key) => acc?.[key], obj);
    };

    // Duyệt toàn bộ schema để xác định field required
    function traverse(components, parentPath = "", parentLabel = "") {
      if (!Array.isArray(components)) return;

      components.forEach((comp) => {
        const key = comp.key;
        if (!key) return;

        const label =
          comp.label &&
            !["text field", "textfield"].includes(comp.label.toLowerCase())
            ? comp.label
            : parentLabel;

        const fullPath = parentPath ? `${parentPath}.${key}` : key;

        // Kiểm tra required
        if (comp.validate?.required) {
          // ⚙️ Lấy giá trị theo cả 2 kiểu: key phẳng và key lồng
          const val1 = formData?.[key];
          const val2 = getDeepValue(formData, fullPath);

          // Xử lý đặc biệt cho các trường như giờ, phút, năm
          const isTimeField =
            /gio|phut|nam/i.test(key) || /gio|phut|nam/i.test(fullPath);

          // Xử lý đặc biệt cho các trường địa danh hành chính
          const isLocationField =
            /maTinh|maXa/i.test(key) || /maTinh|maXa/i.test(fullPath);

          // Xử lý đặc biệt cho các trường họ tên
          const isNameField = /ho|ten/i.test(key) || /ho|ten/i.test(fullPath);

          let value =
            val2 !== undefined && val2 !== null && val2 !== "" ? val2 : val1;

          // Nếu là trường số, chuyển đổi "0" thành giá trị hợp lệ
          if (isTimeField && (value === 0 || value === "0")) {
            value = 0; // Coi 0 là giá trị hợp lệ cho các trường thời gian
          }

          // Kiểm tra giá trị
          const isEmpty =
            value === undefined ||
            value === null ||
            value === "" ||
            (typeof value === "object" &&
              Object.keys(value).length === 0 &&
              !Array.isArray(value));

          // Nếu trường rỗng, thêm vào danh sách thiếu
          if (isEmpty) {
            missing.push(label || "(Không rõ nhãn)");
          }
        }

        // Đệ quy xuống children
        if (Array.isArray(comp.components))
          traverse(comp.components, fullPath, label);
        if (Array.isArray(comp.columns))
          comp.columns.forEach((col) =>
            traverse(col.components, fullPath, label)
          );
        if (Array.isArray(comp.rows))
          comp.rows.forEach((row) =>
            row.forEach((cell) => traverse(cell.components, fullPath, label))
          );
      });
    }

    traverse(eform?.components || []);
    return missing;
  }

  const validatePage1 = () => {
    const flatDetail = flattenAndNormalize(formThongTinChiTietRef.current);

    if (!flatDetail.gio && flatDetail.gio !== 0) flatDetail.gio = "0";
    if (!flatDetail.phut && flatDetail.phut !== 0) flatDetail.phut = "0";

    if (flatDetail.ho && !flatDetail.hoVaTen) {
      flatDetail.hoVaTen = `${flatDetail.ho} ${flatDetail.ten || ""}`.trim();
    }
    if (flatDetail.hoVaTen && !flatDetail.ho) {
      const nameParts = flatDetail.hoVaTen.split(" ");
      if (nameParts.length > 1) {
        flatDetail.ho = nameParts[0];
        flatDetail.ten = nameParts.slice(1).join(" ");
      }
    }

    if (
      flatDetail.maTinh &&
      typeof flatDetail.maTinh === "object" &&
      flatDetail.maTinh.value
    ) {
      flatDetail.maTinh = flatDetail.maTinh.value;
    }
    if (
      flatDetail.maXa &&
      typeof flatDetail.maXa === "object" &&
      flatDetail.maXa.value
    ) {
      flatDetail.maXa = flatDetail.maXa.value;
    }

    const missing1 = validateRequiredFields(dataFormThongTinChung, form);
    const missing2 = validateRequiredFields(
      dataFormThongTinChiTiet,
      flatDetail
    );

    const filteredMissing2 = missing2.filter((field) => {
      // Bỏ qua các trường đã được xử lý đặc biệt
      return ![
        "Giờ, phút chết",
        "Năm:",
        "Họ",
        "Tên",
        "Họ và Tên",
        "Mã địa danh hành chính cấp tỉnh của nơi chết",
        "Mã địa danh hành chính cấp phường/xã của nơi chết",
        "Hình thức nhận kết quả",
      ].includes(field);
    });

    const missing = [...new Set([...missing1, ...filteredMissing2])];

    if (missing.length > 0) {
      confirmAlert({
        title: "Thiếu thông tin bắt buộc",
        message: `Vui lòng nhập đầy đủ các trường sau:\n\n${missing
          .map((m, i) => `${i + 1}. ${m}`)
          .join("\n")}`,
        buttons: [{ label: "Đồng ý" }],
      });
      return false;
    }

    if (!hinhThucNhankq?.value) {
      confirmAlert({
        title: "Thiếu thông tin bắt buộc",
        message: "Vui lòng chọn Hình thức nhận kết quả",
        buttons: [{ label: "Đồng ý" }],
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async (stay) => {
    const ok = validatePage1();
    if (!ok) return false;

    form.TrangThaiHoSo = {
      Ma: "2",
      MoTa: "Chờ duyệt",
      ThoiGianXuLy: new Date().getTime(),
    };
    handleCf(isInsert, handleUpdateInfo, stay, form);
    return true;
  };

  const handleUpdateInfo = async (stay, data = false, noPopup = false) => {
    if (isInsert) return;
    const dsFileAfterUpload = await uploadAllDsFileDinhKem();
    const latestMap = new Map();

    dsFileAfterUpload.forEach((item) => {
      const key = item?.inFo?.procedureForm?.id;
      if (!key) return;

      const files = item?.inFo?.file || [];
      if (files.length > 0) {
        latestMap.set(key, {
          procedureForm: item.inFo.procedureForm,
          order: item.inFo.order,
          case: item.inFo.case,
          detail: item.inFo.detail,
          file: files,
          authentication: item.inFo.authentication,
        });
      }
    });
    (dsFileSubmit || []).forEach((oldItem) => {
      const key = oldItem?.procedureForm?.id;
      if (!key) return;
      const stillExists = dsFileDinhKem.some(
        (f) => f?.inFo?.procedureForm?.id === key
      );

      if (!stillExists) return;
      if (!latestMap.has(key)) {
        latestMap.set(key, oldItem);
      }
    });
    const mergedFiles = Array.from(latestMap.values());
    setDsFileSubmit(mergedFiles);
    const newDataSubmit = {
      ...dataSubmit,
      dossierFormFile: mergedFiles,
    };

    try {
      const res = await cltDanhMucIgateServirces.updateById(
        collection,
        id,
        newDataSubmit
      );
      if (shouldShowApplicantNyc && id && `${id}` !== "0") {
        try {
          await cltDanhMucIgateServirces.updateApplicantNyc(id, applicantNyc);
        } catch (err) {
          dispatch(
            fetchToastNotify({
              type: CONSTANTS.ERROR,
              data: "Cập nhật thông tin người nộp hồ sơ thất bại",
            })
          );
        }
      }
      // const res2 = await cltDanhMucIgateServirces.SubmitHoSoAttp({
      //   _id: inForHoSo?._id?.$oid,
      //   danhmuc_id: inForHoSo?.dmTTHC?._id,
      // });

      dispatch(
        fetchToastNotify({
          type: CONSTANTS.SUCCESS,
          data: "Cập nhật thành công",
        })
      );
      if (!stay) window.location.reload();
    } catch (error) {
      console.error("❌ Lỗi khi cập nhật:", error);
    }
  };

  async function getFileMauHydrated(fileMauGoc, form = {}, contextVars = {}) {
    const fileMauData = fileMauGoc;
    const getDeepValue = (obj, path) => {
      if (!obj || typeof path !== "string") return undefined;
      return path.split(".").reduce((acc, key) => acc?.[key], obj);
    };
    const evalPlaceholder = (exprRaw) => {
      if (typeof exprRaw !== "string") return exprRaw;

      let expr = exprRaw
        .trim()
        .replace(/^\{\{|\}\}$/g, "")
        .trim();
      const [leftRaw, rightRaw] = expr.split("||").map((s) => s?.trim());
      const leftKey = leftRaw?.replace(/['"]/g, "").trim();

      let value = getDeepValue(form, leftKey);
      if (
        (value === undefined || value === null || value === "") &&
        Object.prototype.hasOwnProperty.call(contextVars, leftKey)
      ) {
        value = contextVars[leftKey];
      }

      if (value !== undefined && value !== null && value !== "") {
        return value;
      }

      if (rightRaw) {
        return rightRaw.replace(/^['"]|['"]$/g, "");
      }
      return "………………………………………………………………..";
    };

    const replacePlaceholders = (str) => {
      if (typeof str !== "string") return str;
      let replaced = str.replace(/\{\{[^}]+\}\}/g, (match) =>
        evalPlaceholder(match)
      );

      if (replaced.includes("||")) {
        const [left, right] = replaced.split("||").map((s) => s.trim());
        if (left && !left.includes("{{")) {
          replaced = left;
        } else {
          replaced = right?.replace(/^['"]|['"]$/g, "") || left;
        }
      }

      return replaced;
    };

    return fileMauData.map((item) => {
      const hydrated = {};
      Object.entries(item).forEach(([key, value]) => {
        if (typeof value === "string") {
          hydrated[key] = replacePlaceholders(value);
        } else if (Array.isArray(value)) {
          hydrated[key] = value.map((v) => replacePlaceholders(v));
        } else if (typeof value === "object" && value !== null) {
          hydrated[key] = Object.fromEntries(
            Object.entries(value).map(([k2, v2]) => [
              k2,
              replacePlaceholders(v2),
            ])
          );
        } else {
          hydrated[key] = value;
        }
      });
      return hydrated;
    });
  }

  const dataTable = (dsGiayTo || []).map((item, index) => {
    // Lấy mẫu file tương ứng từ mảng dataFileMau hoặc dsfileMauIgate
    const fileMau =
      (dataFileMau && dataFileMau[index]) ||
      (dsfileMauIgate && dsfileMauIgate[index]) ||
      null;
    return {
      stt: index + 1,
      inFo: item,
      tenGiayTo: `<b>${item?.procedureForm?.name || ""}</b>`,
      loaiBan: `${item?.detail?.quantity || 1} ${item?.detail?.type?.name || ""}`,
      mauGiayTo: fileMau?.nameFileMau || "",
      files: form?.[`file_${index + 1}`] || [],
      dataFileMau: fileMau,
    };
  });

  const dataTableKetQuaTTHC = (inForHoSo?.attachment || []).map(
    (item, index) => {
      const fileMau =
        (dataFileMau && dataFileMau[index]) ||
        (dsfileMauIgate && dsfileMauIgate[index]) ||
        null;
      return {
        stt: index + 1,
        inFo: item,
        tenGiayTo: `<b>${item?.filename || ""}</b>`,
      };
    }
  );

  const handleUpdateDsFileDinhKem = (record, files) => {
    setDsFileDinhKem((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.stt === record.stt);
      const newFiles = Array.isArray(files) ? files : [];

      if (index !== -1) {
        if (newFiles.length === 0) {
          updated.splice(index, 1);
        } else {
          updated[index] = {
            ...updated[index],
            inFo: {
              ...updated[index].inFo,
              file: newFiles,
            },
          };
        }
      } else if (newFiles.length > 0) {
        updated.push({
          stt: record.stt,
          inFo: {
            ...(record.inFo || {}),
            file: newFiles,
          },
        });
      }

      return updated;
    });
  };

  function renderDynamicForm(resEform, form, editable, handleChgConElmt) {
    if (!resEform?.components) return null;

    const renderField = (comp) => {
      const isRequired = comp?.validate?.required || false;

      // 🧩 Lấy options riêng cho Tỉnh, Xã/Phường, Cơ quan cấp CCCD
      let options = [];
      if (comp.key === "province") options = dsTinh;
      else if (["district", "village"].includes(comp.key)) options = dsXaPhuong;
      else if (comp.key === "identityAgency") options = dsCoQuanCapCccd;
      else {
        const hasValidValues =
          Array.isArray(comp.data?.values) &&
          comp.data.values.some(
            (v) =>
              v.label &&
              v.value &&
              v.label.trim() !== "" &&
              v.value.trim() !== ""
          );

        if (hasValidValues) {
          options = comp.data.values.map((v) => ({
            label: v.label,
            value: v.value,
          }));
        } else if (Array.isArray(comp.data?.json)) {
          options = comp.data.json.map((j) => ({
            label: j.ten || j.label || "",
            value: j.organkey || j.ma || j.value || "",
          }));
        }
      }

      // 🧩 Không tự gán mặc định cho province/nation, giữ nguyên giá trị hiện có
      let value = form?.[comp.key] || "";

      // 🧩 Placeholder mặc định
      let placeholder = comp.placeholder;
      if (!placeholder) {
        switch (comp.type) {
          case "select":
            placeholder = `Chọn ${comp.label?.toLowerCase() || "giá trị"}`;
            break;
          case "datetime":
            placeholder = `Chọn ${comp.label?.toLowerCase() || "ngày"}`;
            break;
          case "textfield":
          case "textarea":
            placeholder = `Nhập ${comp.label?.toLowerCase() || "thông tin"}`;
            break;
          default:
            placeholder = "";
        }
      }

      const commonProps = {
        id: comp.key,
        label: <span style={{ fontWeight: 600 }}>{comp.label}</span>,
        placeholder,
        required: isRequired,
        errorLabel:
          (typeof comp.validate?.customMessage === "string" &&
            comp.validate.customMessage) ||
          undefined,
        pattern: comp.validate?.pattern || undefined,
        min: comp.validate?.min,
        max: comp.validate?.max,
        disabled: !editable,
        style: { width: "100%" },
        parentClass: "col-md-12 form-custom",
      };

      // 🧩 Phát hiện widget type calendar
      const isCalendarWidget =
        comp.widget?.type === "calendar" ||
        comp.widget?.dateFormat ||
        comp.widget?.format === "dd/MM/yyyy";

      if (comp.key === "identityAgency") {
        const currentValue = form?.identityAgency
          ? {
            label: form.identityAgency.name,
            value: form.identityAgency.id,
          }
          : null;

        return (
          <FormInputAntd
            key={comp.key}
            {...commonProps}
            type="select"
            options={options.map((opt) => ({
              label: opt.name || opt.label,
              value: opt.id || opt.value,
              data: opt?.raw,
            }))}
            allowClear
            showSearch
            value={currentValue?.value}
            onChange={(val) => {
              const selected = options.find(
                (opt) => opt.id === val || opt.value === val
              );
              setForm((prev) => ({
                ...prev,
                identityAgency: val?.data || null,
              }));
            }}
          />
        );
      }

      switch (comp.type) {
        case "textfield":
          // 🗓 Nếu là textfield nhưng có widget calendar → DatePicker
          if (isCalendarWidget) {
            const df =
              comp?.widget?.format === "dd/MM/yyyy"
                ? "DD/MM/YYYY"
                : comp?.widget?.format || "DD/MM/YYYY";
            const dateVal =
              form?.[comp.key] && dayjs(form[comp.key]).isValid()
                ? dayjs(form[comp.key])
                : null;

            return (
              <FormInputAntd
                key={comp.key}
                {...commonProps}
                type="date"
                placeholder={`Chọn ${comp.label?.toLowerCase() || "ngày"}`}
                value={dateVal}
                dateFormat={df}
                onChange={handleChgConElmt}
              />
            );
          }

          // Trường text thông thường
          return (
            <FormInputAntd
              {...commonProps}
              type="text"
              value={form?.[comp.key] || ""}
              onChange={handleChgConElmt}
            />
          );

        case "number":
          return (
            <FormInputAntd
              {...commonProps}
              type="number"
              value={form?.[comp.key] || ""}
              onChange={handleChgConElmt}
            />
          );

        case "checkbox":
          return (
            <div
              key={comp.key}
              style={{ display: "flex", alignItems: "center" }}
            >
              <FormInputAntd
                key={comp.key}
                {...commonProps}
                type="checkbox"
                style={{ margin: 0 }}
                value={form?.[comp.key] || false}
                onChange={handleChgConElmt}
              />
            </div>
          );

        case "select":
          // Chuẩn hóa value để hiển thị kể cả khi DB lưu NumberInt
          const rawSelectValue =
            typeof form?.[comp.key] === "object"
              ? form?.[comp.key]?.value
              : form?.[comp.key];
          const matchedOption = Array.isArray(options)
            ? options.find(
              (opt) => String(opt.value) === String(rawSelectValue)
            )
            : undefined;
          const finalSelectValue = matchedOption
            ? matchedOption.value
            : rawSelectValue !== undefined && rawSelectValue !== null
              ? String(rawSelectValue)
              : undefined;

          return (
            <FormInputAntd
              key={comp.key}
              {...commonProps}
              type="select"
              options={options}
              allowClear
              showSearch
              value={finalSelectValue}
              onChange={(val) => {
                if (comp.key === "province" && typeof setForm === "function") {
                  setForm((prev) => ({
                    ...prev,
                    province: val,
                    district: null,
                    village: null,
                  }));
                } else {
                  handleChgConElmt({ id: comp.key, value: val });
                }
              }}
            />
          );

        case "datetime": {
          const df =
            comp?.widget?.format === "dd/MM/yyyy"
              ? "DD/MM/YYYY"
              : comp?.widget?.format || "DD/MM/YYYY";
          const dateVal =
            form?.[comp.key] && dayjs(form[comp.key]).isValid()
              ? dayjs(form[comp.key])
              : null;
          return (
            <FormInputAntd
              key={comp.key}
              {...commonProps}
              type="date"
              value={dateVal}
              dateFormat={df}
              placeholder={`Chọn ${comp.label?.toLowerCase() || "ngày"}`}
              onChange={handleChgConElmt}
            />
          );
        }

        case "textarea":
          return (
            <FormInputAntd
              key={comp.key}
              {...commonProps}
              type="textarea"
              value={form?.[comp.key] || ""}
              onChange={handleChgConElmt}
            />
          );

        default:
          if (Array.isArray(comp.components))
            return comp.components.map(renderField);
          return null;
      }
    };

    const renderPanel = (panel) => (
      <div key={panel.key} className="card border mb-3">
        <div
          className="card-header d-flex justify-content-between"
          data-toggle="collapse"
          data-target={`#collapse_${panel.key}`}
          aria-expanded="true"
          style={{
            backgroundColor: "#f5f5f5",
            fontWeight: 600,
            borderRadius: "5px",
            padding: 5,
          }}
        >
          {panel.title || panel.label}
        </div>

        <div id={`collapse_${panel.key}`} className="collapse show">
          <div className="card-body">
            {panel.components?.map((child, i) => {
              if (child.type === "columns" && Array.isArray(child.columns)) {
                return (
                  <div key={i} className="row">
                    {child.columns.map((col, ci) => (
                      <div key={ci} className="col-md-4">
                        {col.components?.map((comp) => (
                          <FormWrapper key={comp.key}>
                            {renderField(comp)}
                          </FormWrapper>
                        ))}
                      </div>
                    ))}
                  </div>
                );
              }
              return (
                <div
                  key={`${panel.key || "panel"}-child-${child.key || i}`}
                  className="row"
                >
                  {Array.isArray(renderField(child))
                    ? renderField(child).map((el, subIdx) => (
                      <div
                        key={`${panel.key || "panel"}-${child.key || i}-sub-${subIdx}`}
                        style={{ width: "100%" }}
                      >
                        {el}
                      </div>
                    ))
                    : renderField(child)}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );

    return resEform.components.map(renderPanel);
  }

  function renderEformChiTiet(
    resEform,
    form,
    editable,
    handleChgConElmt,
    setFormThongTinChiTiet,
    {
      dsTinh = [],
      dsXaPhuongByGroup = {},
      fetchXaPhuongDynamic = () => { },
      dsQuocGia = [],
    } = {}
  ) {
    if (!resEform?.components) return null;

    const components = Array.isArray(resEform.components)
      ? resEform.components
      : typeof resEform.components === "string"
        ? JSON.parse(resEform.components)
        : [];

    // 🧩 Build options — giữ nguyên
    const buildOptions = (comp, groupKey) => {
      if (
        (comp.key === "quocGia" || comp.key === "quocGia1") &&
        Array.isArray(comp?.data?.json)
      ) {
        return comp.data.json.map((j) => ({
          label: j.label ?? j.ten ?? "",
          value: j.value ?? j.ma ?? "",
        }));
      }

      if (["quocGia", "quocGia1", "country"].includes(comp.key))
        return dsQuocGia;
      if (["maTinh", "province"].includes(comp.key)) return dsTinh;
      if (["maXa", "district", "village"].includes(comp.key))
        return dsXaPhuongByGroup[groupKey] || [];

      if (Array.isArray(comp?.data?.json) && comp.data.json.length > 0) {
        return comp.data.json.map((j) => ({
          label: j.label || j.ten || j.name || "",
          value: j.value || j.ma || j.organkey || "",
        }));
      }

      if (Array.isArray(comp?.data?.values) && comp.data.values.length > 0) {
        return comp.data.values
          .filter((v) => v?.label && v?.value)
          .map((v) => ({
            label: String(v.label),
            value: String(v.value),
          }));
      }

      if (
        Array.isArray(comp?.data?.resource) &&
        comp.data.resource.length > 0
      ) {
        return comp.data.resource.map((r) => ({
          label: r.label || r.ten || r.name || "",
          value: r.value || r.id || "",
        }));
      }

      if (
        typeof comp?.data?.custom === "string" &&
        comp.data.custom.trim() !== ""
      ) {
        try {
          const parsed = JSON.parse(comp.data.custom);
          if (Array.isArray(parsed))
            return parsed
              .filter((v) => v?.label && v?.value)
              .map((v) => ({
                label: String(v.label),
                value: String(v.value),
              }));
        } catch {
          try {
            const fn = new Function(
              `let values=[];${comp.data.custom};return values;`
            );
            const values = fn();
            if (Array.isArray(values))
              return values
                .filter((v) => v?.label && v?.value)
                .map((v) => ({
                  label: String(v.label),
                  value: String(v.value),
                }));
          } catch { }
        }
      }

      return [];
    };

    function getFormValue(form, fullKey) {
      if (!form || !fullKey) return undefined;

      // Bỏ prefix layout như panel, row, col, ...
      const ignoreTokens = new Set([
        "panel",
        "panel1",
        "panel2",
        "row",
        "col",
        "fieldset",
        "container",
        "well",
        "table",
      ]);

      const parts = fullKey.split("_").filter((t) => t && !ignoreTokens.has(t));
      const last = parts.at(-1)?.toLowerCase() || "";

      // ✅ 1️⃣ Truy cập trực tiếp key đầy đủ
      if (form[fullKey] !== undefined && form[fullKey] !== null) {
        const v = form[fullKey];
        return v && typeof v === "object" && "value" in v ? v : v;
      }

      // ✅ 2️⃣ Key rút gọn (vd: nksHoTen_Ho → Ho)
      for (let i = 0; i < parts.length; i++) {
        const suffix = parts.slice(i).join("_");
        if (form[suffix] !== undefined) {
          const v = form[suffix];
          return v && typeof v === "object" && "value" in v ? v : v;
        }
      }

      // ✅ 3️⃣ Dạng lồng nhau: form.cha.hoten
      try {
        let current = form;
        for (let i = 0; i < parts.length; i++) {
          const p = parts[i];
          if (p === '__proto__' || p === 'constructor' || p === 'prototype') {
            throw new Error('Phát hiện Prototype Pollution nguy hiểm!');
          }
          if (current && typeof current === "object") {
            current = current[p];
          } else break;
        }
        if (current !== undefined && current !== null) {
          return typeof current === "object" && "value" in current
            ? current
            : current;
        }
      } catch { }

      // ✅ 4️⃣ Logic cũ: nhóm HoTen (panel_nksHoTen_Ho → form.nksHoTen.Ho)
      const idxHoTen = parts.findIndex((p) => /HoTen$/i.test(p));
      if (idxHoTen >= 0) {
        const group = parts[idxHoTen];
        const field = parts.slice(idxHoTen + 1).join("_");
        if (form[group] && form[group][field] !== undefined) {
          const v = form[group][field];
          return v && typeof v === "object" && "value" in v ? v : v;
        }
      }

      // ✅ 5️⃣ Logic cũ: group_field (vd: nksHoTen_Ho → form.nksHoTen.Ho)
      if (parts.length > 1) {
        const group = parts.slice(0, -1).join("_");
        const field = parts[parts.length - 1];
        if (form[group] && form[group][field] !== undefined) {
          const v = form[group][field];
          return v && typeof v === "object" && "value" in v ? v : v;
        }
      }

      // ✅ 6️⃣ Dò động trong các nhóm cha (ưu tiên nhóm cha khớp)
      const groupTokens = parts.slice(0, -1).filter(Boolean);
      const tryGroup = (gk) => {
        const gv = form[gk];
        if (gv && typeof gv === "object" && !Array.isArray(gv)) {
          const mk = Object.keys(gv).find((k) => k.toLowerCase() === last);
          if (mk !== undefined) {
            const v = gv[mk];
            return v && typeof v === "object" && "value" in v ? v : v;
          }
        }
        return undefined;
      };

      // 6a) exact match với segment cha (ví dụ: nycHoTen_Ho → chỉ tìm trong nycHoTen)
      for (let i = groupTokens.length - 1; i >= 0; i--) {
        const seg = groupTokens[i].toLowerCase();
        for (const gk of Object.keys(form)) {
          if (gk.toLowerCase() === seg) {
            const hit = tryGroup(gk);
            if (hit !== undefined) return hit;
          }
        }
      }

      // 6b) match theo token chứa segment cha (vd: "nguoiyeucau_hoten")
      for (let i = groupTokens.length - 1; i >= 0; i--) {
        const seg = groupTokens[i].toLowerCase();
        for (const gk of Object.keys(form)) {
          const tokens = gk.toLowerCase().split("_");
          if (tokens.includes(seg)) {
            const hit = tryGroup(gk);
            if (hit !== undefined) return hit;
          }
        }
      }

      // ✅ 7️⃣ Fallback nếu chỉ có 1 nhóm có field đó
      const candidates = Object.keys(form).filter((gk) => {
        const gv = form[gk];
        return (
          gv &&
          typeof gv === "object" &&
          !Array.isArray(gv) &&
          Object.keys(gv).some((k) => k.toLowerCase() === last)
        );
      });

      if (candidates.length === 1) {
        const gv = form[candidates[0]];
        const mk = Object.keys(gv).find((k) => k.toLowerCase() === last);
        const v = gv[mk];
        return v && typeof v === "object" && "value" in v ? v : v;
      }

      // ✅ 8️⃣ Dò động theo pattern đặc biệt (hoten, ngaysinh, cutru, quequan, ...)
      const dynamicPatterns = [
        "hoten",
        "hovaten",
        "ngaysinh",
        "sinh",
        "quequan",
        "thuongtru",
        "tamtru",
        "cutru",
      ];
      const matchGroups = Object.keys(form).filter((k) =>
        dynamicPatterns.some((p) => k.toLowerCase().includes(p))
      );
      for (const group of matchGroups) {
        const sub = form[group];
        if (sub && typeof sub === "object") {
          const keyMatch = Object.keys(sub).find(
            (k) => k.toLowerCase() === last
          );
          if (keyMatch) {
            const v = sub[keyMatch];
            return v && typeof v === "object" && "value" in v ? v : v;
          }
        }
      }

      // ✅ 9️⃣ Fallback cũ cuối cùng (duyệt toàn bộ theo path)
      let cur = form;
      for (const p of parts) {
        if (p === '__proto__' || p === 'constructor' || p === 'prototype') {
          throw new Error('Phát hiện Prototype Pollution nguy hiểm!');
        }
        if (cur && typeof cur === "object") cur = cur[p];
      }
      if (cur !== undefined) return cur;
      return undefined;
    }

    // 🧩 Render field cơ bản
    const renderLeaf = (comp, parentKey = "", parentLabel = "") => {
      if (!comp || !comp.type) return null;

      // 🧩 Tạo khóa định danh đầy đủ
      const fullKey = parentKey ? `${parentKey}_${comp.key}` : comp.key;
      const options = buildOptions(comp, parentKey);
      const isRequired = !!comp?.validate?.required;

      // 🧠 Ưu tiên label cha nếu label con là mặc định ("Text Field", "TextArea", "Select", ...)
      let displayLabel = comp.label;
      const lowerLabel = (comp.label || "").trim().toLowerCase();
      if (
        [
          "text field",
          "textfield",
          "text",
          "input",
          "textarea",
          "select",
        ].includes(lowerLabel) &&
        parentLabel
      ) {
        displayLabel = parentLabel;
      }

      // 🧩 Common props dùng chung
      const common = {
        id: fullKey,
        label: <span style={{ fontWeight: 600 }}>{displayLabel}</span>,
        required: isRequired,
        errorLabel:
          (typeof comp.validate?.customMessage === "string" &&
            comp.validate.customMessage) ||
          undefined,
        pattern: comp.validate?.pattern || undefined,
        min: comp.validate?.min,
        max: comp.validate?.max,
        disabled: !editable,
        style: { width: "100%" },
        parentClass: "col-md-12 form-custom",
        placeholder:
          comp.placeholder ||
          (comp.type === "select"
            ? `Chọn ${displayLabel?.toLowerCase() || ""}`
            : `Nhập ${displayLabel?.toLowerCase() || ""}`),
      };

      // 🧩 Render theo loại trường
      switch (comp.type) {
        case "textfield":
        case "number":
          // ✅ Nếu là loaiHTTP và chưa có giá trị, áp dụng defaultValue luôn (và lưu vào form)
          if (comp.key === "loaiHTTP") {
            const current = getFormValue(form, fullKey);
            if (current === undefined || current === null || current === "") {
              const def = comp.defaultValue || "KT";
              setFormThongTinChiTiet?.((prev) => ({
                ...prev,
                [fullKey]: def,
                [`__init_${fullKey}`]: true,
              }));
            }
          }
          return (
            <FormInputAntd
              key={fullKey}
              {...common}
              type={comp.type === "number" ? "number" : "text"}
              value={getFormValue(form, fullKey)}
              onChange={(e) =>
                handleChgConElmt({ id: fullKey, value: e.target.value })
              }
            />
          );

        case "select": {
          const keyLower = (comp.key || "").toLowerCase();
          const options = buildOptions(comp, parentKey);

          // 🧠 Lấy giá trị thực từ form (có thể là object hoặc string)
          const rawValue = getFormValue(form, fullKey);
          // 🧩 Chuẩn hóa toàn bộ option.value thành chuỗi
          const normalizedOptions = Array.isArray(options)
            ? options.map((opt) => ({
              ...opt,
              value: String(opt.value),
            }))
            : [];

          // 🧩 Chuẩn hóa giá trị form (string hóa)
          const normalizedValue =
            rawValue && typeof rawValue === "object" && rawValue.value
              ? String(rawValue.value)
              : String(rawValue ?? "");

          // ✅ Tìm option khớp
          const matched = normalizedOptions.find(
            (opt) => String(opt.value) === normalizedValue
          );

          // 🧩 Xác định field địa chỉ (Tỉnh, Huyện, Xã)
          const isAddressField = [
            "matinh",
            "maxa",
            "mahuyen",
            "province",
            "district",
            "village",
          ].some((k) => keyLower.includes(k));

          // 🧩 Tạo giá trị hiển thị đúng cho Select
          let finalDisplayValue;
          if (isAddressField) {
            if (matched) {
              // ✅ có match → hiển thị label tương ứng
              finalDisplayValue = {
                label: matched.label,
                value: matched.value,
              };
            } else if (typeof rawValue === "object" && rawValue.value) {
              // có object trong form (thường lúc khởi tạo)
              finalDisplayValue = {
                label: rawValue.label || rawValue.value,
                value: String(rawValue.value),
              };
            } else if (typeof rawValue === "string" && rawValue) {
              // chỉ có value string, tìm lại label trong options
              const opt = normalizedOptions.find(
                (o) => String(o.value) === rawValue
              );
              finalDisplayValue = opt
                ? { label: opt.label, value: opt.value }
                : { label: rawValue, value: rawValue };
            } else {
              finalDisplayValue = undefined;
            }
          } else {
            // ✅ Các select thường (giới tính, dân tộc, quốc gia,...)
            finalDisplayValue = matched
              ? { label: matched.label, value: matched.value }
              : undefined;
          }

          // 🧠 Mặc định theo key
          const defaults = {
            quocgia: { label: "Việt Nam", value: "VN" },
            dantoc: { label: "Kinh", value: "63001" },
            quoctich: { label: "Việt Nam", value: "VN" },
          };

          let defaultOption = null;
          if (keyLower.includes("quocgia")) defaultOption = defaults.quocgia;
          if (keyLower.includes("dantoc")) defaultOption = defaults.dantoc;
          if (keyLower.includes("quoctich")) defaultOption = defaults.quoctich;

          // ✅ Chỉ set mặc định 1 lần khi form chưa có dữ liệu
          if (!rawValue && defaultOption && !form[`__init_${fullKey}`]) {
            setTimeout(() => {
              setFormThongTinChiTiet((prev) => ({
                ...prev,
                [fullKey]: isAddressField ? defaultOption.value : defaultOption,
                [`__init_${fullKey}`]: true,
              }));
              handleChgConElmt({ id: fullKey, value: defaultOption.value });
            }, 0);
          }

          // 🧩 Render Select
          return (
            <FormInputAntd
              {...common}
              key={fullKey}
              type="select"
              options={normalizedOptions}
              allowClear
              showSearch
              // ✅ Dùng object {label,value} cho tất cả select
              value={finalDisplayValue}
              onChange={(val) => {
                if (isAddressField) {
                  // Địa chỉ → val có thể là string hoặc object
                  const v = typeof val === "object" ? val.value : val;
                  setFormThongTinChiTiet((prev) => ({
                    ...prev,
                    [fullKey]: {
                      label:
                        normalizedOptions.find((o) => o.value === String(v))
                          ?.label || v,
                      value: v,
                    },
                    [`__init_${fullKey}`]: true,
                  }));
                  handleChgConElmt({ id: fullKey, value: v ?? "" });
                } else {
                  // Field thường → object {label,value}
                  setFormThongTinChiTiet((prev) => ({
                    ...prev,
                    [fullKey]: val,
                    [`__init_${fullKey}`]: true,
                  }));
                  handleChgConElmt({ id: fullKey, value: val?.value ?? "" });
                }

                // 🧩 Nếu là tỉnh → reset xã và load lại xã
                if (["maTinh", "province"].includes(comp.key)) {
                  const groupKey = parentKey;
                  const xaKey = `${groupKey}_maXa`;
                  setFormThongTinChiTiet((prev) => ({ ...prev, [xaKey]: "" }));
                  fetchXaPhuongDynamic(
                    groupKey,
                    isAddressField
                      ? typeof val === "object"
                        ? val.value
                        : val
                      : val?.value
                  );
                }
              }}
            />
          );
        }

        case "datetime": {
          // 🧠 Lấy giá trị thực tế từ form (có thể là ISO string, chuỗi, hoặc object)
          const rawValue = getFormValue(form, fullKey);

          // 🧩 Chuẩn hóa sang dayjs object
          let parsedDate = null;

          if (typeof rawValue === "string" && rawValue) {
            // Hỗ trợ cả ISO (2025-11-24T17:00:00.000Z) và định dạng DD/MM/YYYY
            if (dayjs(rawValue, "YYYY-MM-DDTHH:mm:ssZ", true).isValid()) {
              parsedDate = dayjs(rawValue, "YYYY-MM-DDTHH:mm:ssZ");
            } else if (
              dayjs(rawValue, "YYYY-MM-DDTHH:mm:ss.SSSZ", true).isValid()
            ) {
              parsedDate = dayjs(rawValue, "YYYY-MM-DDTHH:mm:ss.SSSZ");
            } else if (dayjs(rawValue, "DD/MM/YYYY", true).isValid()) {
              parsedDate = dayjs(rawValue, "DD/MM/YYYY");
            } else if (dayjs(rawValue).isValid()) {
              parsedDate = dayjs(rawValue);
            }
          } else if (typeof rawValue === "object" && rawValue?.value) {
            const val = rawValue.value;
            if (dayjs(val, "YYYY-MM-DDTHH:mm:ssZ", true).isValid()) {
              parsedDate = dayjs(val, "YYYY-MM-DDTHH:mm:ssZ");
            } else if (dayjs(val, "DD/MM/YYYY", true).isValid()) {
              parsedDate = dayjs(val, "DD/MM/YYYY");
            }
          }

          const displayValue = parsedDate
            ? parsedDate.format("DD/MM/YYYY")
            : "";

          return (
            <FormInputAntd
              {...common}
              key={fullKey}
              type="date"
              value={displayValue}
              placeholder={`Chọn ${displayLabel?.toLowerCase() || "ngày"}`}
              onChange={(e) => {
                const raw = e?.target?.value;

                const isoValue =
                  raw && dayjs(raw, "DD/MM/YYYY", true).isValid()
                    ? dayjs(raw, "DD/MM/YYYY").toISOString()
                    : "";

                setFormThongTinChiTiet((prev) => ({
                  ...prev,
                  [fullKey]: isoValue,
                  [`__init_${fullKey}`]: true,
                }));

                handleChgConElmt({ id: fullKey, value: isoValue });
              }}
            />
          );
        }

        default:
          return null;
      }
    };

    // 🧩 Gom nhóm 3 cột / hàng
    const renderThreeCols = (children, parentKey = "", parentLabel = "") => {
      const rows = [];
      let buffer = [];

      children.forEach((child) => {
        if (child.type === "container") {
          if (buffer.length > 0) {
            rows.push([...buffer]);
            buffer = [];
          }
          rows.push([child]);
        } else {
          buffer.push(child);
          if (buffer.length === 3) {
            rows.push([...buffer]);
            buffer = [];
          }
        }
      });
      if (buffer.length > 0) rows.push([...buffer]);

      return rows.map((pair, idx) => (
        <div
          key={`${parentKey}-${idx}`}
          className="form-row"
          style={{
            display: "flex",
            alignItems: "flex-end",
            // gap: 16,
            marginBottom: 6,
            width: "100%",
            flexWrap: "nowrap",
          }}
        >
          {pair.map((child, ci) => {
            if (child.type === "container") {
              return (
                <div key={ci} style={{ flex: "1 0 100%" }}>
                  {renderStackContainer(child, parentKey)}
                </div>
              );
            }
            return (
              <div
                key={ci}
                style={{
                  flex: "0 0 33.33%",
                  width: "33.33%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                {renderLeaf(child, parentKey, parentLabel)}
              </div>
            );
          })}
        </div>
      ));
    };

    // 🧩 Container
    const renderStackContainer = (comp, parentKey = "") => {
      const fullParent = parentKey ? `${parentKey}_${comp.key}` : comp.key;
      let children = comp.components || [];

      // 🧠 Giữ lại duy nhất Text Field đầu tiên, bỏ các Text Field còn lại
      let firstTextFieldFound = false;
      children = children.filter((child) => {
        if (
          (child.label || "").trim().toLowerCase() === "text field" &&
          !firstTextFieldFound
        ) {
          firstTextFieldFound = true;
          return true;
        }
        if ((child.label || "").trim().toLowerCase() === "text field") {
          return false;
        }
        return true;
      });

      return (
        <div
          key={fullParent}
          style={{
            width: "100%",
            marginBottom: 20,
            padding: "12px 16px",
            border: "1px solid #f0f0f0",
            borderRadius: 6,
            background: "#fafafa",
          }}
        >
          {comp.label && (
            <div style={{ fontWeight: 700, marginBottom: 8, color: "#000" }}>
              {comp.label}
            </div>
          )}
          {renderThreeCols(children, fullParent, comp.label)}
        </div>
      );
    };

    // 🧩 Panel
    const renderPanel = (comp, parentKey = "") => {
      if (!comp?.components) return null;
      const fullParent = parentKey ? `${parentKey}_${comp.key}` : comp.key;
      const isCollapsed = collapsedPanels?.[fullParent] ?? false;
      return (
        <div
          key={fullParent}
          className="card border mb-3"
          style={{
            width: "100%",
            marginBottom: 24,
            borderRadius: 6,
            overflow: "hidden",
          }}
        >
          {/* Header có thể click để thu/mở */}
          <div
            className="card-header d-flex justify-content-between"
            onClick={() =>
              setCollapsedPanels((prev) => ({
                ...prev,
                [fullParent]: !isCollapsed,
              }))
            }
            style={{
              backgroundColor: "#f5f5f5",
              fontWeight: 600,
              borderRadius: "5px",
              padding: 8,
              cursor: "pointer",
              userSelect: "none",
              transition: "background-color 0.2s ease",
            }}
          >
            {comp.title || comp.label}
          </div>

          {/* Hiệu ứng collapse giống Bootstrap */}
          <div
            id={`collapse_${fullParent}`}
            className={`collapse-section ${isCollapsed ? "collapsed" : "expanded"}`}
            style={{
              maxHeight: isCollapsed ? 0 : "none", // ✅ không giới hạn chiều cao khi mở
              overflow: "visible", // ✅ cho phép hiển thị đầy đủ
              transition: "max-height 0.35s ease",
            }}
          >
            <div className="card-body" style={{ padding: "16px 0px" }}>
              {comp.components.map((child, childIdx) => {
                // ✅ luôn có key cho mỗi child
                const childKey = `${fullParent}-child-${child.key || childIdx}`;

                if (child.type === "table" && Array.isArray(child.rows)) {
                  return child.rows.map((row, rIdx) => (
                    <div
                      key={`${childKey}-row-${rIdx}`}
                      className="responsive-row"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "16px",
                        marginBottom: 12,
                        width: "100%",
                      }}
                    >
                      {row.map((cell, cIdx) => (
                        <div
                          key={`${childKey}-cell-${rIdx}-${cIdx}`}
                          className="responsive-cell"
                          style={{
                            flex: "0 0 calc(50% - 8px)",
                            maxWidth: "calc(50% - 8px)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                          }}
                        >
                          {(cell.components || []).map((cc, ccIdx) => (
                            // ✅ key cho mỗi component trong cell
                            <div
                              key={`${childKey}-cc-${rIdx}-${cIdx}-${cc.key || ccIdx}`}
                            >
                              {renderAny(cc, fullParent)}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ));
                }

                if (["container", "columns", "fieldset"].includes(child.type)) {
                  return (
                    <div key={childKey}>{renderAny(child, fullParent)}</div>
                  );
                }

                return (
                  <div key={childKey}>{renderLeaf(child, fullParent)}</div>
                );
              })}

              {/* Responsive fix */}
              <style>
                {`
      @media (max-width: 768px) {
        .responsive-row {
          flex-direction: column !important;
          gap: 12px !important;
          width: 100% !important;
        }
        .responsive-cell {
          flex: 0 0 100% !important;
          max-width: 100% !important;
          width: 100% !important;
          display: flex !important;
          flex-direction: column !important;
          justify-content: flex-start !important;
        }
      }
    `}
              </style>
            </div>
          </div>
        </div>
      );
    };

    // 🧩 Tổng thể
    const renderAny = (comp, parentKey = "") => {
      if (comp.type === "panel") return renderPanel(comp, parentKey);
      if (comp.type === "columns" && Array.isArray(comp.columns)) {
        const flat = comp.columns.flatMap((col) => col.components || []);
        return (
          <div key={comp.key} style={{ width: "100%" }}>
            {renderThreeCols(flat, parentKey)}
          </div>
        );
      }
      if (comp.type === "container")
        return renderStackContainer(comp, parentKey);
      if (comp.type === "fieldset")
        return (
          <>
            {(comp.components || []).map((c, idx) => (
              <div
                key={`${parentKey}-${comp.key || "fieldset"}-${c.key || idx}`}
              >
                {renderAny(c, parentKey)}
              </div>
            ))}
          </>
        );

      return <div style={{ width: "100%" }}>{renderLeaf(comp, parentKey)}</div>;
    };

    return (
      <>
        {/* 🎨 Responsive chỉ áp dụng cho mobile */}
        <style>
          {`
          @media (max-width: 768px) {
            .form-row {
              flex-direction: column !important;
              flex-wrap: nowrap !important;
              align-items: stretch !important;
              gap: 12px !important;
            }

            .form-row > div {
              flex: 1 1 100% !important;
              width: 100% !important;
              min-width: 100% !important;
              max-width: 100% !important;
            }

            .card-body, .container {
              padding: 12px !important;
            }

            .card-header {
              font-size: 15px !important;
              padding: 8px 10px !important;
            }
          }
        `}
        </style>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: "100%",
            gap: 16,
          }}
        >
          {stripTextFieldLabel(components).map((comp, idx) => (
            <div key={comp.key || `comp-${idx}`}>{renderAny(comp)}</div>
          ))}
        </div>
      </>
    );
  }

  const stripTextFieldLabel = (arr = []) =>
    arr
      .filter((item) => {
        const label = (item.label || "").trim().toLowerCase();
        const key = (item.key || "").trim().toLowerCase();

        // Các trường hợp này đặc biệt cần giữ lại
        if (
          label === "text field" &&
          key !== "hovaten_nks" &&
          key !== "hovatennguoiyeucau" &&
          key !== "hovatencha" &&
          key !== "hovatenme"
        )
          return false;
        return true;
      })
      .map((item) => {
        const newItem = { ...item };

        // Đệ quy xuống các cấp con (container/panel/columns/rows)
        if (Array.isArray(item.components)) {
          newItem.components = stripTextFieldLabel(item.components);
        }
        if (Array.isArray(item.columns)) {
          newItem.columns = item.columns.map((col) => ({
            ...col,
            components: stripTextFieldLabel(col.components || []),
          }));
        }
        if (Array.isArray(item.rows)) {
          newItem.rows = item.rows.map((row) =>
            row.map((cell) => ({
              ...cell,
              components: stripTextFieldLabel(cell.components || []),
            }))
          );
        }
        return newItem;
      });

  const isLienThongKhaiTuThuongTru =
    danhMucTTHC?.link === "/ho-so-lien-thong-khai-tu-thuong-tru-tam-tru";

  console.log(2, form)
  return (
    <>
      {(!isLienThongKhaiTuThuongTru || step === 1) && (
        <div className="main portlet">
          <Breadcrumb
            items={[
              {
                title: <i className="fa fa-home" aria-hidden="true"></i>,
                href: HOME_PAGE + "/home",
              },
              {
                title: danhMucTTHC?.Ten || inForHoSo?.LoaiHoSo?.Ten,
                href: HOME_PAGE + danhMucTTHC?.link + "/" + id,
              },
            ]}
          />
          <div className="header-main">
            <div className="portlet-title">
              <div className="caption">
                <div className="d-flex w-100">
                  <div className="d-flex">
                    <Divider
                      className="ml-1"
                      orientation="left"
                      orientationMargin="0"
                    >
                      Xác nhận hồ sơ
                    </Divider>
                  </div>
                </div>
              </div>
              <div className="action d-flex gap-2">
                {editable ? (
                  isLienThongKhaiTuThuongTru ? (
                    <Button
                      disabled={!editable}
                      className="antd-button-default"
                      type="primary"
                      onClick={() => {
                        const ok = validatePage1();
                        if (!ok) return;
                        setHasMountedStep2(true);
                        setStep(2);
                      }}
                    >
                      Tiếp theo
                    </Button>
                  ) : (
                    <Button
                      disabled={!editable}
                      className="antd-button-default"
                      onClick={() => handleSubmit(false)}
                      type="primary"
                    >
                      Gửi đi
                    </Button>
                  )
                ) : isLienThongKhaiTuRoute ? (
                  <Button
                    className="antd-button-default"
                    onClick={() => {
                      setHasMountedStep2(true);
                      setStep(2);
                    }}
                    type="primary"
                  >
                    Tiếp tục
                  </Button>
                ) : (
                  <Button
                    className="antd-button-default"
                    onClick={() => window.history.back()}
                    type="primary"
                  >
                    Quay lại
                  </Button>
                )}
              </div>
            </div>
          </div>
          {/* {!isInsert && <TienTrinhHoSo hoso={inForHoSo} />} */}
          <div className="card border">
            <div
              className="card-header d-flex justify-content-between mb-2"
              data-toggle="collapse"
              data-target="#collapseNguoiNop"
              aria-expanded="true"
              aria-controls="collapseNguoiNop"
              style={expanderStyles}
            >
              <span style={captionSubject} className="text-uppercase">
                THÔNG TIN NGƯỜI NỘP HỒ SƠ
              </span>
              <span>
                <i className="fas fa-chevron-up" />
                <i className="fas fa-chevron-down" />
              </span>
            </div>

            <div className="collapse show" id="collapseNguoiNop">
              <div className="card-body">
                {idApplicantEForm ? (
                  <div className="form-body" ref={formRefAttaches}>
                    {dataFormThongTinChung ? (
                      renderDynamicForm(
                        dataFormThongTinChung,
                        form,
                        editable,
                        handleChgConElmt
                      )
                    ) : (
                      <div>Đang tải biểu mẫu...</div>
                    )}
                  </div>
                ) : (
                  <div className="form-body">
                    <FormWrapper>
                      <FormInputAntd
                        parentClass="col-md-6"
                        id="chonDonViXuLy"
                        type="select"
                        required={true}
                        disabled={!editable}
                        label="Chọn cơ quan thực hiện"
                        // ✅ Lọc trùng value & thêm key unique
                        options={[
                          ...new Map(
                            (dsCoQuan || []).map((o, i) => [
                              o.value,
                              { ...o, key: `${o.value}_${i}` },
                            ])
                          ).values(),
                        ]}
                        value={idDonViSelected || undefined}
                        placeholder="Chọn Cơ quan Thực hiện"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onChange={(val) => {
                          setIdDonViSelected(val || null);
                        }}
                      />
                      <FormInputAntd
                        parentClass="col-md-6"
                        id="truonghopgiaiquyet"
                        type="select"
                        required={true}
                        disabled={!dsQuyTrinh?.length > 0}
                        label="Trường hợp giải quyết"
                        // ✅ Lọc trùng value & thêm key unique
                        options={dsQuyTrinh}
                        value={idApplicantEForm || undefined}
                        placeholder="Chọn Trường hợp giải quyết"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onChange={(val) => {
                          setIdApplicantEForm(val?.value || null);
                          setIdEform(val?.idEform || null);
                          setIdQuyTrinh(val?.idQuyTrinh || null);
                        }}
                      />
                    </FormWrapper>
                  </div>
                )}
                {shouldShowApplicantNyc && (
                  <>
                    <Divider orientation="left" orientationMargin="0">
                      Thông tin người nộp (ngoài Tam Kỳ)
                    </Divider>
                    {loadingApplicantNyc ? (
                      <div>Đang tải thông tin người nộp...</div>
                    ) : (
                      <div className="form-body">
                        <FormWrapper>
                          <FormInputAntd
                            parentClass="col-md-6"
                            id="nycFullname"
                            type="text"
                            required={true}
                            disabled={!editable}
                            label="Họ và tên người nộp"
                            value={getApplicantNycField(
                              ["fullname", "nycHoTen", "hovaten"],
                              ""
                            )}
                            placeholder="Nhập họ và tên"
                            onChange={handleChgApplicantNyc}
                          />
                          <FormInputAntd
                            parentClass="col-md-6"
                            id="nycIdentityNumber"
                            type="text"
                            required={false}
                            disabled={!editable}
                            label="Số định danh/CCCD"
                            value={getApplicantNycField(
                              ["identityNumber", "nycSoGiayToTuyThan"],
                              ""
                            )}
                            placeholder="Nhập số định danh/CCCD"
                            onChange={handleChgApplicantNyc}
                            pattern={CONSTANTS.CCCD_PATTERN}
                            errorLabel="Số định danh/CCCD không hợp lệ"
                          />
                        </FormWrapper>
                        <FormWrapper>
                          <FormInputAntd
                            parentClass="col-md-6"
                            id="nycPhoneNumber"
                            type="text"
                            required={true}
                            disabled={!editable}
                            label="Số điện thoại"
                            value={getApplicantNycField(
                              ["phoneNumber", "nycSoDienThoai"],
                              ""
                            )}
                            placeholder="Nhập số điện thoại"
                            onChange={handleChgApplicantNyc}
                            pattern={/(0|\+84)(3[2-9]|5[6|8|9]|7[0|6-9]|8[1-9]|9[0-9])\d{7}$/}
                            errorLabel="Số điện thoại không hợp lệ"
                          />
                          <FormInputAntd
                            parentClass="col-md-6"
                            id="nycEmail"
                            type="text"
                            required={false}
                            disabled={!editable}
                            label="Email"
                            value={getApplicantNycField(["email", "nycEmail"], "")}
                            placeholder="Nhập email"
                            onChange={handleChgApplicantNyc}
                            pattern={CONSTANTS.EMAIL_PATTERN}
                            errorLabel="Email không hợp lệ"
                          />
                        </FormWrapper>
                        <FormWrapper>
                          <FormInputAntd
                            parentClass="col-md-12"
                            id="nycAddress"
                            type="text"
                            required={false}
                            disabled={!editable}
                            label="Địa chỉ"
                            value={getApplicantNycField(
                              ["address", "nycDiaChi"],
                              ""
                            )}
                            placeholder="Nhập địa chỉ"
                            onChange={handleChgApplicantNyc}
                          />
                        </FormWrapper>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {first && (
              <>
                <div
                  className="card-header d-flex justify-content-between mb-2"
                  data-toggle="collapse"
                  data-target="#thongtinchitiet"
                  aria-expanded="true"
                  aria-controls="thongtinchitiet"
                  style={expanderStyles}
                >
                  <span style={captionSubject} className="text-uppercase">
                    THÔNG TIN CHI TIẾT
                  </span>
                  <span>
                    <i className="fas fa-chevron-up" />
                    <i className="fas fa-chevron-down" />
                  </span>
                </div>
                <div className="collapse show" id="thongtinchitiet">
                  <div className="card-body">
                    <div className="form-body" ref={formRefAttaches}>
                      {renderEformChiTiet(
                        dataFormThongTinChiTiet,
                        formThongTinChiTiet,
                        editable,
                        handleChgThongTinChiTiet,
                        setFormThongTinChiTiet,
                        {
                          dsTinh,
                          dsXaPhuongByGroup,
                          fetchXaPhuongDynamic,
                          dsQuocGia: [],
                        }
                      )}
                    </div>{" "}
                  </div>
                </div>
              </>
            )}

            {/* form ĐƠN ĐỀ NGHỊ CẤP GIẤY CHỨNG NHẬN CƠ SỞ ĐỦ ĐIỀU KIỆN AN TOÀN THỰC PHẨM */}
            {idApplicantEForm && (
              <>
                <div
                  className="card-header d-flex justify-content-between mb-2"
                  data-toggle="collapse"
                  data-target="#collapseDonDeNghi"
                  aria-expanded="true"
                  aria-controls="collapseDonDeNghi"
                  style={expanderStyles}
                >
                  <span style={captionSubject} className="text-uppercase">
                    THÀNH PHẦN HỒ SƠ
                  </span>
                  <span>
                    <i className="fas fa-chevron-up" />
                    <i className="fas fa-chevron-down" />
                  </span>
                </div>
                <div className="collapse show" id="collapseDonDeNghi">
                  <div className="card-body mb-2">
                    <TableGiayToKemTheo
                      data={(dataTable || []).map((row) => {
                        const found = dsFileDinhKem?.find((f) => f.stt === row.stt);
                        return {
                          ...row,
                          files: found?.inFo?.file || row.files || [],
                        };
                      })}
                      fileIgate={dataFileMau?.length > 0}
                      onFileChange={handleUpdateDsFileDinhKem}
                      onRemoveFile={handleUpdateDsFileDinhKem}
                      isDisabled={!editable}
                    />
                  </div>
                </div>
                <div
                  className="card-header d-flex justify-content-between mb-2"
                  data-toggle="collapse"
                  data-target="#collapseHinhThucNhanKetQua"
                  aria-expanded="true"
                  aria-controls="collapseHinhThucNhanKetQua"
                  style={expanderStyles}
                >
                  <span style={captionSubject} className="text-uppercase">
                    HÌNH THỨC NHẬN KẾT QUẢ HỒ SƠ
                  </span>
                  <span>
                    <i className="fas fa-chevron-up" />
                    <i className="fas fa-chevron-down" />
                  </span>
                </div>
                <div className="collapse show" id="collapseHinhThucNhanKetQua">
                  <div className="card-body mb-2">
                    <FormWrapper>
                      <FormInputAntd
                        parentClass="col-md-6"
                        id="hinhThucNhanKetQua"
                        type="select"
                        required={true}
                        disabled={!editable}
                        label="Hình thức nhận kết quả"
                        options={dsHinhThucNhanKq || []}
                        value={hinhThucNhankq || undefined}
                        placeholder="Chọn Hình thức nhận kết quả"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onChange={(val) => {
                          if (!val) {
                            setHinhThucNhankq(undefined);
                            return;
                          }
                          // const { label, value } = val;
                          setHinhThucNhankq(val);
                        }}
                      />
                    </FormWrapper>
                  </div>
                </div>
                {inForHoSo?.attachment?.length > 0 && (
                  <>
                    <div
                      className="card-header d-flex justify-content-between mb-2"
                      data-toggle="collapse"
                      data-target="#collapseKqXuLy"
                      aria-expanded="true"
                      aria-controls="collapseKqXuLy"
                      style={expanderStyles}
                    >
                      <span style={captionSubject} className="text-uppercase">
                        KẾT QUẢ XỬ LÝ HỒ SƠ
                      </span>
                      <span>
                        <i className="fas fa-chevron-up" />
                        <i className="fas fa-chevron-down" />
                      </span>
                    </div>
                    <div className="collapse show" id="collapseKqXuLy">
                      <div className="card-body mb-2">
                        <TableKetQuaTTHC
                          data={(dataTableKetQuaTTHC || []).map((row) => {
                            const found = dsFileDinhKem?.find(
                              (f) => f.stt === row.stt
                            );
                            return {
                              ...row,
                              files: found?.inFo?.file || row.files || [],
                            };
                          })}
                          fileIgate={dataFileMau?.length > 0}
                          onFileChange={handleUpdateDsFileDinhKem}
                          onRemoveFile={handleUpdateDsFileDinhKem}
                          isDisabled={!editable}
                        />
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          {/* THÔNG TIN GIẤY TỜ ĐÍNH KÈM TỪ KHO */}
          {form?.giayToDinhKem && form.giayToDinhKem.length > 0 && (
            <div className="card border mt-3">
              <div
                className="card-header d-flex justify-content-between"
                data-toggle="collapse"
                data-target="#collapseGiayTo"
                aria-expanded="true"
                aria-controls="collapseGiayTo"
                style={expanderStyles}
              >
                <span style={captionSubject} className="text-uppercase">
                  {"TÀI LIỆU CÁ NHÂN ĐÍNH KÈM".toUpperCase()}
                </span>
                <span>
                  <i className="fas fa-chevron-up" />
                  <i className="fas fa-chevron-down" />
                </span>
              </div>
              <div className="collapse show" id="collapseGiayTo">
                <div className="card-body">
                  <table className="table table-bordered table-hover">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: 50, textAlign: 'center' }}>STT</th>
                        <th>Tên giấy tờ</th>
                        <th style={{ width: 150, textAlign: 'center' }}>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {form.giayToDinhKem.map((item, index) => {
                        const docId = typeof item === 'object' ? item.id : item;
                        const name = typeof item === 'object' ? item.name : "Tài liệu đính kèm";
                        return (
                          <tr key={index}>
                            <td align="center">{index + 1}</td>
                            <td>
                              <i className="fa fa-file-text text-primary" style={{ marginRight: 8 }} />
                              <strong>{name}</strong>
                              <div style={{ fontSize: 12, color: 'gray', marginTop: 4 }}>ID: {docId}</div>
                            </td>
                            <td align="center">
                              <Button
                                type="primary"
                                icon={<i className="fa fa-download" style={{ marginRight: 4 }} />}
                                onClick={() => handleDownloadGiayTo(docId, name)}
                              >
                                Tải về
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      )}


      {hasMountedStep2 && (
        <div style={{ display: step === 2 ? "block" : "none" }}>
          <ChiTietHoSoXoaThuongTruTamTru
            onBack={() => setStep(1)}
            onSubmitPage1={handleUpdateInfo}
            initialData={{
              form,
              formThongTinChiTiet,
            }}
          />
        </div>
      )}
    </>
  );
}
export default ChiTietHoSoIgate;
